/*
  Encuentra tu talla (Zendelaya)

  - Perfil de la clienta (estatura, peso, edad, forma del cuerpo, sujetador y cómo le gusta llevar la ropa),
    guardado en este navegador (localStorage, clave "zd-perfil-talla") y, con sesión iniciada, en la cuenta del cliente
    (assets/zendelaya-cuenta.js). La autorización es el aviso del paso 1: al continuar queda en el perfil
    "consentimiento" (fecha y texto aceptado), que también se guarda en la cuenta como constancia.
  - Motor: está en el servidor (_zendelaya-app/worker.js, /apps/zendelaya/talla), no en este archivo.
    La página solo dice qué productos tienen ficha (data-zd-ficha = handle del producto); el servidor lee la ficha,
    calcula y devuelve la talla y el detalle que se muestra. Si el servidor no responde se ofrece la Guía de medidas.
  - Abre con cualquier enlace "Encuentra tu talla": [data-zd-finder], [data-ld-finder], [data-zcl-finder]
    o con el evento "zendelaya:size-finder" ({ detail: { product: handle } }).
  - Con perfil guardado, marca la talla recomendada en los botones de talla de los elementos con data-zd-ficha.

  Textos e imágenes: <script type="application/json" id="zd-talla-config"> (snippets/zendelaya-talla-config.liquid).
*/
(function () {
  if (window.ZendelayaTalla) return;

  var CLAVE = 'zd-perfil-talla';
  var VERSION = 1;

  /* ------------------------------------------------------------------ Configuración */
  var config = {};
  function leerConfig() {
    var el = document.getElementById('zd-talla-config');
    if (!el) return;
    try { config = JSON.parse(el.textContent) || {}; } catch (e) { config = {}; }
  }
  leerConfig();
  function t(clave, defecto) {
    var v = config.textos && config.textos[clave];
    return v != null && v !== '' ? v : defecto;
  }

  /* ------------------------------------------------------------------ Motor (en el servidor)
     Las reglas y fórmulas están en el servidor (_zendelaya-app/worker.js, ruta /apps/zendelaya/talla).
     Aquí solo se envía el perfil y los productos, y se recibe la talla y el detalle que se muestra. */
  var MOTOR_URL = config.motor_url || '/apps/zendelaya/talla';
  var MAX_POR_PETICION = 60;
  var CACHE_TALLAS = 'zd-talla-cache';

  /* Solo los datos que usa el motor (sin la constancia ni fechas) */
  function datosMotor(p) {
    if (!p) return null;
    return {
      estatura: p.estatura, peso: p.peso, edad: p.edad || null, abdomen: p.abdomen || null, caderas: p.caderas || null,
      preferencia: p.preferencia || 'normal', habitual: p.habitual || null, medidas: p.medidas || null, sujetador: p.sujetador || null
    };
  }
  function clavePerfil(p) { return JSON.stringify(datosMotor(p)); }

  /* Tallas ya calculadas en esta visita (por perfil): las tarjetas no vuelven a preguntar al cambiar de página */
  var cacheTallas = null;
  /* Como máximo 10 minutos: si cambian las medidas de una prenda, la recomendación se vuelve a calcular */
  var CACHE_MINUTOS = 10;
  function vigente(c) { return c && c.creado && Date.now() - c.creado < CACHE_MINUTOS * 60000; }
  function tallasGuardadas(p) {
    var k = clavePerfil(p);
    if (cacheTallas && cacheTallas.perfil === k && vigente(cacheTallas)) return cacheTallas.tallas;
    var c = null;
    try { c = JSON.parse(sessionStorage.getItem(CACHE_TALLAS) || 'null'); } catch (e) {}
    /* Una caché de antes de los estados (sin "estados") o vencida se descarta: se vuelve a calcular */
    cacheTallas = c && c.perfil === k && c.estados && vigente(c) ? c : { perfil: k, tallas: {}, estados: {}, creado: Date.now() };
    return cacheTallas.tallas;
  }
  /* Estado de una prenda ya calculada: {t: talla} | {no: 1, c: más cercana, m: medida, tp: apretada/suelta} | null (sin ficha).
     undefined: todavía no se ha calculado. Con un servidor anterior (sin "estados") se deduce de la talla. */
  function estadoGuardado(p, h) {
    var tallas = tallasGuardadas(p);
    if (h in cacheTallas.estados) return cacheTallas.estados[h];
    if (h in tallas) return tallas[h] ? { t: tallas[h] } : null;
    return undefined;
  }
  function guardarTallas(p, tallas, estados) {
    var actuales = tallasGuardadas(p);
    Object.keys(tallas || {}).forEach(function (h) { actuales[h] = tallas[h]; });
    Object.keys(estados || {}).forEach(function (h) { cacheTallas.estados[h] = estados[h]; });
    try { sessionStorage.setItem(CACHE_TALLAS, JSON.stringify(cacheTallas)); } catch (e) {}
  }

  /* ---------- Registro (fase B): número de cada recomendación mostrada, para unirla con el carrito y el pedido */
  var REGISTROS = 'zd-registros';
  var DIAS_REGISTRO = 30;
  function visita() {
    var v = null;
    try { v = sessionStorage.getItem('zd-visita'); } catch (e) {}
    if (!v) {
      v = Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
      try { sessionStorage.setItem('zd-visita', v); } catch (e) {}
    }
    return v;
  }
  function leerRegistros() {
    var r = {};
    try { r = JSON.parse(localStorage.getItem(REGISTROS) || '{}') || {}; } catch (e) {}
    var limite = Date.now() - DIAS_REGISTRO * 864e5;
    Object.keys(r).forEach(function (h) { if (!r[h] || r[h].f < limite) delete r[h]; });
    return r;
  }
  function guardarRegistro(handle, id) {
    if (!handle || !id) return;
    var r = leerRegistros();
    r[handle] = { id: id, f: Date.now() };
    var orden = Object.keys(r).sort(function (a, b) { return r[b].f - r[a].f; }).slice(0, 60);
    var out = {};
    orden.forEach(function (h) { out[h] = r[h]; });
    try { localStorage.setItem(REGISTROS, JSON.stringify(out)); } catch (e) {}
    aplicarRegistroPagina();
  }
  function registroDe(handle) {
    var r = handle ? leerRegistros()[handle] : null;
    return r ? r.id : null;
  }
  /* Para el carrito: número de la recomendación del producto del botón que se pulsó */
  function registroPara(origen) {
    if (!origen || !origen.closest) return null;
    if (dlg && dlg.contains(origen)) return estado ? registroDe(estado.handle) : null;
    var el = origen.closest('[data-zd-ficha]') || (origen.closest('[data-zd-ficha-scope]') || document.createElement('i')).querySelector('[data-zd-ficha]');
    return el ? registroDe(fichaDe(el)) : null;
  }
  /* Página de producto: el formulario del tema lleva el número como propiedad oculta de la línea */
  function aplicarRegistroPagina() {
    var picker = document.querySelector('variant-picker [data-zd-ficha], .variant-picker [data-zd-ficha]');
    if (!picker) return;
    var id = registroDe(fichaDe(picker));
    var seccion = picker.closest('.shopify-section') || document;
    var form = seccion.querySelector('form[action*="/cart/add"]') || document.querySelector('product-form-component form[action*="/cart/add"]');
    if (!form) return;
    var input = form.querySelector('input[name="properties[_zd_rec]"]');
    if (!id) { if (input) input.remove(); return; }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_zd_rec]';
      form.appendChild(input);
    }
    if (input.value !== id) input.value = id;
  }
  document.addEventListener('zendelaya:agregado', function (e) {
    var d = e.detail || {};
    if (!d.rec) return;
    var url = config.evento_url || MOTOR_URL.replace(/\/talla$/, '/evento');
    fetch(url, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin', keepalive: true,
      body: JSON.stringify({ tipo: 'carrito', rec: d.rec, producto: d.producto || null, talla: d.talla || null, visita: visita() })
    }).catch(function () {});
  });

  function pedirMotor(perfil, productos, detalle, origen) {
    return fetch(MOTOR_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ perfil: datosMotor(perfil), productos: productos || [], detalle: detalle || null, visita: visita(), origen: origen || null })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (d) {
      if (d && d.tallas) guardarTallas(perfil, d.tallas, d.estados);
      return d;
    });
  }

  var MOTIVOS = {
    sin_ficha: 'el producto no tiene ficha de tallas (zendelaya.ficha_tallas) con horma y medidas',
    ficha_incompleta: 'la ficha no tiene una horma válida o no tiene pecho (P01), cintura (P02 o P10) ni cadera (P11)'
  };

  /* ------------------------------------------------------------------ Perfil (navegador) */
  function leerPerfil() {
    try {
      var p = JSON.parse(localStorage.getItem(CLAVE) || 'null');
      return p && p.v === VERSION && p.estatura && p.peso ? p : null;
    } catch (e) { return null; }
  }
  function guardarPerfil(p) {
    p.v = VERSION;
    p.actualizado = Date.now();
    avisoPendiente = true;
    try { localStorage.setItem(CLAVE, JSON.stringify(p)); } catch (e) {}
    marcarTodo();
    document.dispatchEvent(new CustomEvent('zendelaya:perfil-talla', { detail: { perfil: p } }));
  }
  function borrarPerfil() {
    try { localStorage.removeItem(CLAVE); } catch (e) {}
    marcarTodo();
    document.dispatchEvent(new CustomEvent('zendelaya:perfil-talla', { detail: { perfil: null } }));
  }

  /* ------------------------------------------------------------------ Marcar la talla recomendada en la página */
  var SELECTOR_FINDER = '[data-zd-finder], [data-ld-finder], [data-zcl-finder]';

  /* Handle del producto con ficha (el valor de data-zd-ficha) */
  function fichaDe(el) {
    var v = el.getAttribute('data-zd-ficha');
    return v && /^[a-z0-9][a-z0-9-]*$/.test(v) ? v : null;
  }

  var enCurso = {};   // productos ya pedidos al servidor en esta página (también si falló: no se reintenta en bucle)
  function marcarTodo() {
    var perfil = leerPerfil();
    var elementos = Array.prototype.slice.call(document.querySelectorAll('[data-zd-ficha]'));
    var tallas = perfil ? tallasGuardadas(perfil) : {};
    var faltan = [];
    elementos.forEach(function (el) {
      var handle = fichaDe(el);
      if (perfil && handle && !(handle in tallas) && !enCurso[clavePerfil(perfil) + '|' + handle] && faltan.indexOf(handle) < 0) faltan.push(handle);
      var est = perfil && handle ? estadoGuardado(perfil, handle) : null;
      if (perfil && handle && est === undefined) est = 'pendiente';
      marcar(el, perfil && handle ? tallas[handle] || null : null, est);
    });
    for (var i = 0; i < faltan.length; i += MAX_POR_PETICION) pedirGrupo(perfil, faltan.slice(i, i + MAX_POR_PETICION));
  }

  /* Pide al motor un grupo de prendas. Nunca deja una prenda en "Calculando…": si el servidor no la devuelve,
     falla o tarda más de 12 s, queda sin talla (se ve el texto general del perfil) y se reintenta en la próxima página. */
  function pedirGrupo(perfil, grupo) {
    var clave = clavePerfil(perfil);
    grupo.forEach(function (h) { enCurso[clave + '|' + h] = true; });
    var cerrar = function () {
      var tallas = tallasGuardadas(perfil), vacios = {}, hay = false;
      grupo.forEach(function (h) { if (!(h in tallas) && !(h in cacheTallas.estados)) { vacios[h] = null; hay = true; } });
      if (hay) guardarTallas(perfil, {}, vacios);
      programarMarcado();
    };
    var limite = new Promise(function (_, no) { setTimeout(function () { no(new Error('tiempo de espera')); }, 12000); });
    Promise.race([pedirMotor(perfil, grupo), limite]).then(cerrar).catch(function (e) {
      cerrar();
      console.warn('[Encuentra tu talla] No se pudo calcular la talla de las prendas de esta página:', e && e.message);
    });
  }

  function marcar(el, talla, est) {
      var scope = el.closest('[data-zd-ficha-scope]') || el;
      /* Estado para otras partes de la página (p. ej. el look de la semana): ok | no | pendiente | vacío */
      var nombreEstado = !est ? '' : est === 'pendiente' ? 'pendiente' : est.t ? 'ok' : 'no';
      if (el.getAttribute('data-zd-estado') !== nombreEstado) el.setAttribute('data-zd-estado', nombreEstado);
      var tallaEst = est && est.t ? est.t : '';
      if ((el.getAttribute('data-zd-talla') || '') !== tallaEst) {
        if (tallaEst) el.setAttribute('data-zd-talla', tallaEst); else el.removeAttribute('data-zd-talla');
      }
      var cercana = est && est.no && est.c ? est.c : '';
      if ((el.getAttribute('data-zd-cercana') || '') !== cercana) {
        if (cercana) el.setAttribute('data-zd-cercana', cercana); else el.removeAttribute('data-zd-cercana');
      }
      etiquetaTarjeta(el, est && est.t ? est.t : null);

      scope.querySelectorAll('[data-size], input[type="radio"]').forEach(function (b) {
        var valor = b.tagName === 'INPUT' ? b.value : b.getAttribute('data-size');
        var destino = b.tagName === 'INPUT' ? b.closest('label') : b;
        if (!destino) return;
        var es = talla && valor === talla;
        var punto = destino.querySelector(':scope > .zd-rec-dot');
        if (es && !punto) {
          punto = document.createElement('span');
          punto.className = 'zd-rec-dot';
          punto.setAttribute('aria-hidden', 'true');
          destino.appendChild(punto);
          destino.setAttribute('data-zd-rec', '');
          destino.setAttribute('title', t('marca', 'Tu talla recomendada'));
        } else if (!es && punto) {
          punto.remove();
          destino.removeAttribute('data-zd-rec');
          destino.removeAttribute('title');
        }
      });

      scope.querySelectorAll(SELECTOR_FINDER).forEach(function (f) {
        if (!f.hasAttribute('data-zd-finder-texto')) f.setAttribute('data-zd-finder-texto', f.textContent.trim());
        var texto = talla ? t('tu_talla', 'Tu talla: [talla]').split('[talla]').join(talla)
          : est && est.no ? (est.c ? t('no_viene_cercana', 'No viene en tu talla · la más cercana: [talla]').split('[talla]').join(est.c) : t('no_viene', 'No viene en tu talla'))
          : f.getAttribute('data-zd-finder-texto');
        if (f.textContent !== texto) f.textContent = texto;
      });

      scope.querySelectorAll('[data-zd-fila]').forEach(function (f) { pintarFila(f, scope, talla, est); });
  }

  /* Etiqueta «Tu talla: M» sobre la foto de las tarjetas (colecciones, búsqueda, looks, favoritos). Solo cuando hay
     talla: en las prendas que no le quedan no se pone nada en la cuadrícula. No va en la ficha ni en el look de la semana. */
  function etiquetaTarjeta(el, talla) {
    if (el.closest('variant-picker, .variant-picker, [data-zld], [data-zd-sin-etiqueta]')) return;
    var host = el.classList.contains('zd-root') ? el.parentElement : el.querySelector('.ld__cmedia, .zcl__cmedia');
    if (!host) return;
    var chip = host.querySelector(':scope > .zd-tu-talla');
    if (!talla) { if (chip) chip.remove(); return; }
    if (!chip) {
      chip = document.createElement('span');
      chip.className = 'zd-tu-talla';
      host.appendChild(chip);
    }
    var txt = t('chip', 'Tu talla: [talla]').split('[talla]').join(talla);
    if (chip.textContent !== txt) chip.textContent = txt;
  }

  /* Aviso de una sola vez al terminar el perfil: explica la etiqueta «Tu talla» */
  var AVISO = 'zd-aviso-talla';
  var avisoPendiente = false;
  function mostrarAviso() {
    avisoPendiente = false;
    try { if (localStorage.getItem(AVISO)) return; localStorage.setItem(AVISO, '1'); } catch (e) { return; }
    var caja = document.createElement('div');
    caja.className = 'zd-aviso-talla';
    caja.setAttribute('role', 'status');
    var txt = document.createElement('span');
    txt.textContent = t('aviso_perfil', 'Listo. Ahora verás «Tu talla» en cada prenda.');
    var x = document.createElement('button');
    x.type = 'button';
    x.textContent = t('cerrar', 'Cerrar');
    x.addEventListener('click', function () { caja.remove(); });
    caja.appendChild(txt); caja.appendChild(x);
    document.body.appendChild(caja);
    setTimeout(function () { caja.remove(); }, 8000);
  }

  /* Fila bajo las tallas de la ficha: sin perfil invita; con perfil dice la talla de esta prenda y la elige */
  var NOMBRE_MEDIDA = { pecho: 'el pecho', cintura: 'la cintura', cadera: 'la cadera' };
  function pintarFila(f, scope, talla, est) {
    var tit = f.querySelector('[data-zd-fila-titulo]'), sub = f.querySelector('[data-zd-fila-sub]'), ir = f.querySelector('[data-zd-fila-ir]');
    if (!f.__original) f.__original = [tit.textContent, sub.textContent, ir.textContent];
    var perfil = leerPerfil();
    var textos;
    if (talla) textos = [t('fila_talla', 'Tu talla en esta prenda: [talla]').split('[talla]').join(talla), t('fila_talla_texto', 'Según tu perfil. Toca para ver cómo te queda.'), t('fila_por_que', 'Ver por qué')];
    else if (perfil && est === 'pendiente') textos = [t('fila_calculando', 'Calculando tu talla…'), t('fila_calculando_texto', 'Un momento.'), ''];
    else if (perfil && est && est.no) {
      var donde = est.m && est.tp ? t('fila_no_donde', ': te quedará [tipo] en [medida]').split('[tipo]').join(est.tp).split('[medida]').join(NOMBRE_MEDIDA[est.m] || est.m) : '';
      textos = [t('fila_no', 'No viene en tu talla'),
        est.c ? t('fila_no_texto', 'La más cercana es [talla][donde].').split('[talla]').join(est.c).split('[donde]').join(donde) : t('fila_no_sin', 'Ninguna talla de esta prenda te queda.'),
        t('fila_no_ver', 'Ver detalle')];
    }
    else if (perfil) textos = [t('fila_listo', 'Tu perfil está listo'), t('fila_listo_texto', 'Toca para ver tu talla en esta prenda.'), t('fila_ver', 'Ver mi talla') + ' →'];
    else textos = f.__original;
    if (tit.textContent !== textos[0]) tit.textContent = textos[0];
    if (sub.textContent !== textos[1]) sub.textContent = textos[1];
    if (ir.textContent !== textos[2]) ir.textContent = textos[2];
    f.classList.toggle('is-ok', !!talla);
    f.classList.toggle('is-no', !!(est && est.no));
    /* Elegir la talla recomendada una sola vez, si la clienta no ha tocado las tallas y está disponible */
    if (talla && config.elegir_talla !== false && !scope.__zdTocado && scope.__zdElegida !== talla) {
      var entrada = Array.prototype.filter.call(scope.querySelectorAll('input[type="radio"]'), function (i) { return i.value === talla; })[0];
      scope.__zdElegida = talla;
      if (entrada && !entrada.checked && entrada.getAttribute('data-option-available') !== 'false') entrada.click();
    }
    if (!scope.__zdEscucha) {
      scope.__zdEscucha = true;
      scope.addEventListener('change', function (e) { if (e.isTrusted) scope.__zdTocado = true; });
    }
  }
  document.addEventListener('click', function (e) {
    var f = e.target && e.target.closest && e.target.closest('[data-zd-fila]');
    if (!f) return;
    e.preventDefault();
    abrir(f.getAttribute('data-product-handle'), f);
  });

  var pendiente = null;
  function programarMarcado() {
    clearTimeout(pendiente);
    pendiente = setTimeout(function () { marcarTodo(); aplicarRegistroPagina(); }, 150);
  }

  /* ------------------------------------------------------------------ Datos del producto */
  var cacheProductos = {};
  function cargarProducto(handle) {
    if (!handle) return Promise.reject(new Error('sin producto'));
    if (cacheProductos[handle]) return cacheProductos[handle];
    var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var url = raiz + 'products/' + encodeURIComponent(handle) + '?view=zd-talla';
    /* En la vista previa de un tema sin publicar, pedir los datos a ese mismo tema */
    var tema = window.Shopify && Shopify.theme;
    if (tema && tema.id && tema.role && tema.role !== 'main') url += '&preview_theme_id=' + tema.id;
    cacheProductos[handle] = fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (txt) {
        try { return JSON.parse(txt); } catch (e) {
          console.warn('[Encuentra tu talla] La vista ?view=zd-talla no devolvió datos válidos. ¿Está subido templates/product.zd-talla.liquid? Inicio de la respuesta:', txt.slice(0, 200));
          throw e;
        }
      })
      .catch(function (e) { delete cacheProductos[handle]; throw e; });
    return cacheProductos[handle];
  }

  /* Variante a agregar: la del botón de talla del mismo panel (respeta el color mostrado);
     si no, la de la página de producto con las demás opciones iguales; si no, la primera disponible. */
  function varianteParaTalla(producto, talla, contexto) {
    if (contexto && contexto.mapa && contexto.mapa[talla]) return { id: contexto.mapa[talla].id, available: contexto.mapa[talla].available };
    if (!producto || !producto.variants) return null;
    var si = producto.sizeIndex;
    var conTalla = producto.variants.filter(function (v) { return si >= 0 && v.options[si] === talla; });
    if (!conTalla.length) return null;
    var actualId = null;
    var input = document.querySelector('product-form-component input[name="id"], form[action*="/cart/add"] input[name="id"]');
    if (input && contexto && contexto.esPagina) actualId = Number(input.value);
    var actual = producto.variants.filter(function (v) { return v.id === actualId; })[0];
    if (actual) {
      var igual = conTalla.filter(function (v) {
        return v.options.every(function (o, i) { return i === si || o === actual.options[i]; });
      })[0];
      if (igual) return igual;
    }
    return conTalla.filter(function (v) { return v.available; })[0] || conTalla[0];
  }

  function contextoDe(boton) {
    var ctx = { mapa: null, esPagina: false, ficha: null };
    if (!boton) return ctx;
    /* El producto tiene ficha (respaldo si no se pueden leer los datos del producto) */
    var conFicha = boton.closest('[data-zd-ficha]');
    if (!conFicha) {
      /* Fila "Encuentra tu talla" de la ficha: la marca está en el mismo grupo de tallas, no alrededor del botón */
      var grupo = boton.closest('[data-zd-ficha-scope]');
      var handle = boton.getAttribute('data-product-handle');
      var marca = grupo && grupo.querySelector('[data-zd-ficha]');
      if (marca && (!handle || fichaDe(marca) === handle)) conFicha = marca;
    }
    if (conFicha) ctx.ficha = fichaDe(conFicha);
    /* Foto y nombre de la tarjeta, por si no se pueden leer los datos del producto */
    var tarjeta = boton.closest('product-card, [data-ld-card], [data-zcl-card], .product-card');
    if (tarjeta) {
      var img = tarjeta.querySelector('img');
      var nombre = tarjeta.querySelector('.ld__ptitle, .zcl__ptitle, .product-card__title, [class*="title"] a, a[href*="/products/"]');
      ctx.imagen = img ? (img.currentSrc || img.src) : null;
      ctx.titulo = nombre ? nombre.textContent.trim() : '';
    }
    var scope = boton.closest('[data-zd-ficha-scope]') || boton.closest('[data-zd-panel], [data-ld-panel], [data-zcl-panel-tallas]') || boton.closest('[data-zd-ficha]');
    if (boton.closest('variant-picker, .variant-picker')) ctx.esPagina = true;
    if (scope && !ctx.esPagina) {
      var mapa = {};
      scope.querySelectorAll('[data-size][data-variant-id]').forEach(function (b) {
        var id = parseInt(b.getAttribute('data-variant-id'), 10);
        if (id) mapa[b.getAttribute('data-size')] = { id: id, available: !b.disabled };
      });
      if (Object.keys(mapa).length) ctx.mapa = mapa;
    }
    return ctx;
  }

  /* Respaldo en la página de producto: variantes de la guía de medidas y foto/título de la página */
  function productoDeLaPagina() {
    var el = document.querySelector('script[data-zd-gm-variants]');
    if (!el) return null;
    var datos;
    try { datos = JSON.parse(el.textContent); } catch (e) { return null; }
    var meta = function (prop) { var m = document.querySelector('meta[property="' + prop + '"]'); return m ? m.getAttribute('content') : null; };
    return { title: meta('og:title') || document.title, image: meta('og:image'), sizeIndex: datos.size, variants: datos.variants || [], ficha: null };
  }

  /* ------------------------------------------------------------------ Ventana */
  var dlg = null;
  var estado = null; // { paso, borrador, producto, contexto, unidades }

  function h(tag, attrs, hijos) {
    var el = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'text') el.textContent = attrs[k];
      else if (k === 'html') el.innerHTML = attrs[k];
      else if (k.slice(0, 2) === 'on') el.addEventListener(k.slice(2), attrs[k]);
      else if (attrs[k] != null && attrs[k] !== false) el.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    });
    (hijos || []).forEach(function (c) { if (c != null) el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return el;
  }

  function crearVentana() {
    if (dlg) return dlg;
    inyectarEstilos();
    dlg = h('dialog', { class: 'zft zd-lateral', 'aria-labelledby': 'zft-titulo' });
    dlg.innerHTML =
      '<div class="zft__box">' +
        '<div class="zft__head">' +
          '<p class="zft__titulo" id="zft-titulo"></p>' +
          '<button type="button" class="zft__x" data-zft-cerrar aria-label=""><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
        '</div>' +
        '<div class="zft__progreso" aria-hidden="true"><span></span></div>' +
        '<div class="zft__cuerpo" data-zft-cuerpo></div>' +
        '<div class="zft__pie" data-zft-pie></div>' +
        '<div class="zft__toast" role="status" aria-live="polite" data-zft-toast></div>' +
      '</div>';
    dlg.querySelector('#zft-titulo').textContent = t('titulo', 'Encuentra tu talla');
    dlg.querySelector('[data-zft-cerrar]').setAttribute('aria-label', t('cerrar', 'Cerrar'));
    dlg.addEventListener('click', function (e) {
      if (!e.target.closest('.zft__info')) dlg.querySelectorAll('.zft__info.is-abierto').forEach(function (x) {
        x.classList.remove('is-abierto');
        x.querySelector('.zft__i').setAttribute('aria-expanded', 'false');
      });
      if (e.target === dlg) cerrar();
      if (e.target.closest('[data-zft-cerrar]')) cerrar();
    });
    dlg.addEventListener('cancel', function (e) {
      /* Esc con una lista abierta solo cierra la lista */
      if (dlg.querySelector('.zft__opciones:not([hidden])')) e.preventDefault();
    });
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('zft-abierta');
      if (avisoPendiente) setTimeout(mostrarAviso, 300);
    });
    document.body.appendChild(dlg);
    return dlg;
  }

  function cerrar() { if (dlg && dlg.open) dlg.close(); }

  /* Modo perfil (desde el panel de cuenta): llenar o editar los datos sin una prenda; al final muestra el perfil */
  function editarPerfil() {
    crearVentana();
    var perfil = leerPerfil();
    estado = {
      paso: 0,
      modoPerfil: true,
      borrador: perfil ? JSON.parse(JSON.stringify(perfil)) : { unidades: { alt: 'cm', peso: 'kg' }, sujetador: null, preferencia: 'normal' },
      producto: false,
      handle: null,
      contexto: contextoDe(null),
      error: ''
    };
    if (!dlg.open) {
      dlg.showModal();
      document.documentElement.classList.add('zft-abierta');
    }
    pintar();
  }

  function abrir(handle, boton) {
    crearVentana();
    var perfil = leerPerfil();
    estado = {
      paso: perfil ? RESULTADO : 0,
      borrador: perfil ? JSON.parse(JSON.stringify(perfil)) : { unidades: { alt: 'cm', peso: 'kg' }, sujetador: null, preferencia: 'normal' },
      producto: null,
      handle: handle,
      contexto: contextoDe(boton),
      error: ''
    };
    if (!dlg.open) {
      dlg.showModal();
      document.documentElement.classList.add('zft-abierta');
    }
    pintar();
    cargarProducto(handle).then(function (p) {
      if (!estado || estado.handle !== handle) return;
      estado.producto = p;
      if (estado.paso === RESULTADO) pintar();
    }).catch(function (err) {
      if (handle) console.warn('[Encuentra tu talla] No se pudieron leer los datos del producto "' + handle + '":', err && err.message);
      if (!estado || estado.handle !== handle) return;
      var c = estado.contexto;
      var respaldo = c.esPagina ? productoDeLaPagina() : null;
      if (!respaldo && c.ficha) respaldo = { title: c.titulo || '', image: c.imagen || null, sizeIndex: -1, variants: [], ficha: null };
      estado.producto = respaldo || false;
      if (estado.paso === RESULTADO) pintar();
    });
  }

  function toast(texto) {
    var el = dlg.querySelector('[data-zft-toast]');
    el.textContent = texto;
    el.classList.add('is-visible');
    clearTimeout(el.__t);
    el.__t = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  function pintar() {
    var cuerpo = dlg.querySelector('[data-zft-cuerpo]');
    var pie = dlg.querySelector('[data-zft-pie]');
    cuerpo.innerHTML = '';
    pie.innerHTML = '';
    var total = RESULTADO;
    var barra = dlg.querySelector('.zft__progreso span');
    barra.style.width = (estado.paso >= RESULTADO ? 100 : ((estado.paso + 1) / total) * 100) + '%';
    dlg.classList.toggle('is-resultado', estado.paso === RESULTADO);
    [pasoBasicos, pasoForma, pasoHabitual, pasoMedidas, pasoPreferencia, pasoResultado][estado.paso](cuerpo, pie);
    cuerpo.scrollTop = 0;
  }

  var RESULTADO = 5;
  var TITULOS_PASO = ['Información básica', 'Forma de tu silueta', 'Talla que usas normalmente', 'Tus medidas (opcional)', 'Cómo te gusta llevar la ropa'];
  function contador(n) {
    return h('div', { class: 'zft__encabezado' }, [
      h('p', { class: 'zft__paso', text: t('paso', 'Paso [n] de [total]').replace('[n]', n).replace('[total]', RESULTADO) }),
      h('h2', { class: 'zft__titulo-paso', text: t('titulo_paso_' + n, TITULOS_PASO[n - 1]) })
    ]);
  }

  function botones(pie, opciones) {
    if (opciones.atras) pie.appendChild(h('button', { type: 'button', class: 'zft__btn zft__btn--sec', text: t('atras', 'Atrás'), onclick: opciones.atras }));
    pie.appendChild(h('button', { type: 'button', class: 'zft__btn', text: opciones.texto || t('continuar', 'Continuar'), onclick: opciones.siguiente }));
  }

  function ir(paso) { estado.paso = paso; estado.error = ''; pintar(); }

  /* ---------- Paso 1: estatura, peso y edad ---------- */
  function rango(desde, hasta, paso) { var a = []; for (var v = desde; v <= hasta; v += paso) a.push(v); return a; }

  /* Lista desplegable propia (blanca, del ancho del campo, con scroll): solo se elige, no se escribe */
  function selector(id, etiqueta, opciones, valor, defecto) {
    var actual = valor;
    var activo = null;
    var buffer = '', bufferT = null;
    var texto = h('span', { class: 'zft__select-valor' });
    var flecha = h('span', { class: 'zft__select-flecha', 'aria-hidden': 'true', html: '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>' });
    var btn = h('button', { type: 'button', id: id, class: 'zft__select-btn', 'aria-haspopup': 'listbox', 'aria-expanded': 'false' }, [texto, flecha]);
    var lista = h('ul', { class: 'zft__opciones', role: 'listbox', tabindex: '-1', 'aria-label': etiqueta, hidden: true });
    opciones.forEach(function (o) {
      lista.appendChild(h('li', { id: id + '-' + o.valor, role: 'option', 'data-valor': o.valor, 'aria-selected': o.valor === actual ? 'true' : 'false', text: o.texto }));
    });
    var wrap = h('div', { class: 'zft__select' }, [btn, lista]);

    function pintarValor() {
      var o = opciones.filter(function (x) { return x.valor === actual; })[0];
      texto.textContent = o ? o.texto : t('elegir', 'Selecciona');
      texto.classList.toggle('is-vacio', !o);
    }
    function marcar(li, centrar) {
      if (activo) activo.classList.remove('is-activo');
      activo = li;
      if (!li) return;
      li.classList.add('is-activo');
      lista.setAttribute('aria-activedescendant', li.id);
      if (centrar) lista.scrollTop = li.offsetTop - lista.clientHeight / 2 + li.offsetHeight / 2;
      else li.scrollIntoView({ block: 'nearest' });
    }
    function fuera(e) { if (!wrap.contains(e.target)) cerrarLista(false); }
    function abrirLista() {
      lista.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      marcar(lista.querySelector('[data-valor="' + (actual != null ? actual : defecto) + '"]') || lista.firstElementChild, true);
      lista.focus({ preventScroll: true });
      document.addEventListener('pointerdown', fuera, true);
    }
    function cerrarLista(foco) {
      lista.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('pointerdown', fuera, true);
      if (foco) btn.focus();
    }
    function elegir(li) {
      actual = Number(li.getAttribute('data-valor'));
      lista.querySelectorAll('[aria-selected="true"]').forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
      li.setAttribute('aria-selected', 'true');
      pintarValor();
      cerrarLista(true);
    }
    btn.addEventListener('click', function () { if (lista.hidden) abrirLista(); else cerrarLista(true); });
    btn.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); abrirLista(); }
    });
    lista.addEventListener('click', function (e) { var li = e.target.closest('li'); if (li) elegir(li); });
    lista.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k === 'ArrowDown' || k === 'ArrowUp') {
        e.preventDefault();
        var sig = activo && (k === 'ArrowDown' ? activo.nextElementSibling : activo.previousElementSibling);
        if (sig) marcar(sig);
      } else if (k === 'Home' || k === 'End') {
        e.preventDefault();
        marcar(k === 'Home' ? lista.firstElementChild : lista.lastElementChild);
      } else if (k === 'Enter' || k === ' ') {
        e.preventDefault();
        if (activo) elegir(activo);
      } else if (k === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        cerrarLista(true);
      } else if (k === 'Tab') {
        cerrarLista(false);
      } else if (/^\d$/.test(k)) {
        /* Escribir números salta a ese valor de la lista (sin escribir en el campo) */
        buffer += k;
        clearTimeout(bufferT);
        bufferT = setTimeout(function () { buffer = ''; }, 800);
        var li = Array.prototype.filter.call(lista.children, function (x) { return x.getAttribute('data-valor').indexOf(buffer) === 0; })[0];
        if (li) marcar(li, true);
      }
    });
    pintarValor();
    return { wrap: wrap, valor: function () { return actual; } };
  }

  function unidadesDe(lista, actual, alCambiar, vacio) {
    return h('div', { class: 'zft__unidades' + (vacio ? ' zft__unidades--vacio' : ''), role: vacio ? null : 'group', 'aria-hidden': vacio ? 'true' : null },
      lista.map(function (u) {
        return h('button', {
          type: 'button', class: 'zft__unidad', tabindex: vacio ? '-1' : null, 'aria-pressed': u === actual ? 'true' : 'false', text: u,
          onclick: vacio ? null : function () { alCambiar(u); }
        });
      }));
  }

  function filaCampo(id, etiqueta, sel, extra, nota) {
    var fila = h('div', { class: 'zft__campo' + (nota ? ' zft__campo--nota' : '') });
    if (nota) fila.appendChild(h('p', { class: 'zft__campo-nota', text: nota }));
    fila.appendChild(h('label', { for: id, class: 'zft__label', text: etiqueta }));
    fila.appendChild(h('div', { class: 'zft__control' }, [sel.wrap, extra]));
    return fila;
  }

  function limitar(v, min, max) { return Math.min(max, Math.max(min, v)); }

  function pasoBasicos(cuerpo, pie) {
    var b = estado.borrador;
    var u = b.unidades || { alt: 'cm', peso: 'kg' };
    b.unidades = u;
    var enIn = u.alt === 'in', enLb = u.peso === 'lb';
    /* Valores por defecto para que no sea obligatorio escribirlos */
    if (!b.estatura) b.estatura = 160;
    if (!b.peso) b.peso = 65;
    var altVal = b.estatura ? (enIn ? limitar(Math.round(b.estatura / 2.54), 55, 79) : limitar(Math.round(b.estatura), 140, 200)) : null;
    var pesoVal = b.peso ? (enLb ? limitar(Math.round(b.peso / 0.4536), 77, 330) : limitar(Math.round(b.peso), 35, 150)) : null;

    cuerpo.appendChild(contador(1));
    cuerpo.appendChild(h('p', { class: 'zft__intro', text: t('intro', 'Son 5 preguntas y toma 1 minuto. Las respondes una sola vez y te recomendamos tu talla en cada prenda que tiene medidas.') }));

    var opcion = function (sufijo) { return function (v) { return { valor: v, texto: v + sufijo }; }; };
    var sAlt = selector('zft-alt', t('estatura', 'Estatura'), (enIn ? rango(55, 79, 1) : rango(140, 200, 1)).map(opcion(enIn ? 'in' : 'cm')), altVal, enIn ? 63 : 160);
    var sPeso = selector('zft-peso', t('peso', 'Peso'), (enLb ? rango(77, 330, 1) : rango(35, 150, 1)).map(opcion(enLb ? 'lb' : 'kg')), pesoVal, enLb ? 143 : 65);
    var sEdad = selector('zft-edad', t('edad', 'Edad'), rango(14, 90, 1).map(opcion(' ' + t('anos', 'años'))), b.edad || null, 30);

    function leer() {
      var a = sAlt.valor(), p = sPeso.valor(), e = sEdad.valor();
      b.estatura = a ? (enIn ? a * 2.54 : a) : null;
      b.peso = p ? (enLb ? p * 0.4536 : p) : null;
      b.edad = e || null;
    }
    cuerpo.appendChild(filaCampo('zft-alt', t('estatura', 'Estatura'), sAlt, unidadesDe(['cm', 'in'], u.alt, function (n) { leer(); u.alt = n; pintar(); })));
    cuerpo.appendChild(filaCampo('zft-peso', t('peso', 'Peso'), sPeso, unidadesDe(['kg', 'lb'], u.peso, function (n) { leer(); u.peso = n; pintar(); })));
    /* La edad es opcional (se puede continuar sin ella): se dice en la etiqueta para no presentarla como obligatoria */
    cuerpo.appendChild(filaCampo('zft-edad', t('edad_opcional', 'Edad (opcional)'), sEdad, unidadesDe(['kg', 'lb'], '', null, true),
      t('edad_nota', 'Si nos la dices, afinamos la recomendación: la edad cambia cómo se reparte el peso.')));

    var error = h('p', { class: 'zft__error', role: 'alert', text: estado.error || '' });
    cuerpo.appendChild(error);

    var politica = config.politica_url || '';
    var legal = h('p', { class: 'zft__legal' });
    var txt = t('consentimiento', 'Al hacer clic en Continuar autorizas el tratamiento de tus medidas para recomendarte una talla y, de forma anónima, para mejorar nuestras recomendaciones. Se guardan en este dispositivo y, si inicias sesión, en tu cuenta, para que las veas en cualquier dispositivo. Son opcionales y puedes borrarlas cuando quieras.');
    legal.appendChild(document.createTextNode(txt + ' '));
    if (politica) legal.appendChild(h('a', { href: politica, target: '_blank', rel: 'noopener', text: t('politica', 'Política de privacidad') }));
    cuerpo.appendChild(legal);

    botones(pie, {
      siguiente: function () {
        leer();
        if (!b.estatura) return mostrarError(error, t('error_estatura', 'Elige tu estatura.'));
        if (!b.peso) return mostrarError(error, t('error_peso', 'Elige tu peso.'));
        b.aceptado = new Date().toISOString();
        /* Constancia de la autorización: qué texto vio y cuándo continuó */
        b.consentimiento = { fecha: Date.now(), texto: txt + (politica ? ' ' + t('politica', 'Política de privacidad') + ' (' + politica + ')' : '') };
        ir(1);
      }
    });
  }

  function mostrarError(el, texto) { el.textContent = texto; return false; }

  /* ---------- Paso 2: forma del abdomen y de las caderas ---------- */
  function figuraAbdomen(nivel) {
    var b = { plano: 0, medio: 5, abultado: 11 }[nivel];
    var d = 'M44 8C40 8 38 12 38 16C38 20 39 23 40 25C34 27 30 31 29 38C28 46 30 52 31 58C32 66 31 74 31 82C31 92 33 100 34 108C35 114 34 120 34 124L58 124C58 116 57 110 57 104' +
      'C' + (58 + b * 0.6) + ' 98 ' + (59 + b) + ' 92 ' + (59 + b) + ' 86' +
      'C' + (59 + b) + ' 80 ' + (58 + b * 0.7) + ' 75 ' + (56 + b * 0.3) + ' 71' +
      'C55 67 56 63 58 60C63 57 64 51 62 46C60 41 55 40 53 36C52 32 52 28 50 25C51 23 52 20 52 16C52 12 49 8 44 8Z';
    return '<svg viewBox="16 0 64 128" aria-hidden="true"><path class="zft__silueta" d="' + d + '"/><path class="zft__zona" d="M' + (26) + ' 86H' + (66 + b) + '"/></svg>';
  }
  function figuraCaderas(nivel) {
    var w = { rectas: 0, medias: 8, anchas: 16 }[nivel];
    var L = 50 - 15 - w / 2, R = 50 + 15 + w / 2;
    var d = 'M50 6C46 6 44 9 44 13C44 17 45 19 46 21C40 22 34 23 32 27C30 32 32 40 34 46C36 52 37 56 37 60' +
      'C' + (37 - w * 0.3) + ' 66 ' + L + ' 72 ' + L + ' 80' +
      'C' + L + ' 92 ' + (L + 3) + ' 108 ' + (L + 6) + ' 124L49 124L50 98L51 124L' + (R - 6) + ' 124' +
      'C' + (R - 3) + ' 108 ' + R + ' 92 ' + R + ' 80' +
      'C' + R + ' 72 ' + (63 + w * 0.3) + ' 66 63 60C63 56 64 52 66 46C68 40 70 32 68 27C66 23 60 22 54 21C55 19 56 17 56 13C56 9 54 6 50 6Z';
    return '<svg viewBox="16 0 68 128" aria-hidden="true"><path class="zft__silueta" d="' + d + '"/><path class="zft__zona" d="M' + (L - 6) + ' 80H' + (R + 6) + '"/></svg>';
  }

  function grupoOpciones(titulo, clave, opciones, figura) {
    var b = estado.borrador;
    var imgs = config.imagenes || {};
    var lista = h('div', { class: 'zft__formas', role: 'radiogroup', 'aria-label': titulo });
    opciones.forEach(function (o) {
      var sel = b[clave] === o.valor;
      var media = h('span', { class: 'zft__forma-img' });
      var src = imgs[clave + '_' + o.valor];
      if (src) media.appendChild(h('img', { src: src, alt: '', loading: 'lazy' }));
      else media.innerHTML = figura(o.valor);
      lista.appendChild(h('button', {
        type: 'button', class: 'zft__forma', role: 'radio', 'aria-checked': sel ? 'true' : 'false',
        onclick: function () { b[clave] = o.valor; lista.querySelectorAll('.zft__forma').forEach(function (x) { x.setAttribute('aria-checked', 'false'); }); this.setAttribute('aria-checked', 'true'); }
      }, [media, h('span', { class: 'zft__forma-txt', text: o.texto })]));
    });
    return h('div', { class: 'zft__grupo' }, [h('p', { class: 'zft__label', text: titulo }), lista]);
  }

  function pasoForma(cuerpo, pie) {
    cuerpo.appendChild(contador(2));
    cuerpo.appendChild(grupoOpciones(t('abdomen', 'Forma de tu abdomen'), 'abdomen', [
      { valor: 'plano', texto: t('abdomen_plano', 'Plano') },
      { valor: 'medio', texto: t('abdomen_medio', 'Medio') },
      { valor: 'abultado', texto: t('abdomen_abultado', 'Abultado') }
    ], figuraAbdomen));
    cuerpo.appendChild(grupoOpciones(t('caderas', 'Forma de tus caderas'), 'caderas', [
      { valor: 'rectas', texto: t('caderas_rectas', 'Rectas') },
      { valor: 'medias', texto: t('caderas_medias', 'Medias') },
      { valor: 'anchas', texto: t('caderas_anchas', 'Anchas') }
    ], figuraCaderas));
    var error = h('p', { class: 'zft__error', role: 'alert' });
    cuerpo.appendChild(error);
    botones(pie, {
      atras: function () { ir(0); },
      siguiente: function () {
        /* Opcional: si no elige, el cálculo usa una forma neutra (medio y medias) */
        ir(2);
      }
    });
  }

  /* ---------- Paso 3: talla que usa normalmente (opcional) ---------- */
  var TALLAS_HABITUALES = { blusa: ['XS', 'S', 'M', 'L', 'XL'], pantalon: ['6', '8', '10', '12', '14', '16'] };
  function pasoHabitual(cuerpo, pie) {
    var b = estado.borrador;
    b.habitual = b.habitual || {};
    cuerpo.appendChild(contador(3));
    cuerpo.appendChild(h('p', { class: 'zft__intro', text: t('habitual_intro', 'Cuéntanos qué talla usas normalmente. Nos ayuda a afinar nuestra recomendación.') }));
    function fila(titulo, clave) {
      var lista = h('div', { class: 'zft__chips', role: 'radiogroup', 'aria-label': titulo });
      TALLAS_HABITUALES[clave].concat(['nose']).forEach(function (v) {
        lista.appendChild(h('button', {
          type: 'button', class: 'zft__chip' + (v === 'nose' ? ' zft__chip--ancho' : ''), role: 'radio',
          'aria-checked': b.habitual[clave] === v ? 'true' : 'false', text: v === 'nose' ? t('no_se', 'No sé') : v,
          onclick: function () {
            b.habitual[clave] = v;
            lista.querySelectorAll('.zft__chip').forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
            this.setAttribute('aria-checked', 'true');
          }
        }));
      });
      return h('div', { class: 'zft__grupo' }, [h('p', { class: 'zft__label', text: titulo }), lista]);
    }
    cuerpo.appendChild(fila(t('habitual_blusa', 'En blusas'), 'blusa'));
    cuerpo.appendChild(fila(t('habitual_pantalon', 'En pantalones'), 'pantalon'));
    botones(pie, { atras: function () { ir(1); }, siguiente: function () { ir(3); } });
  }

  /* ---------- Paso 4: medidas reales con cinta (opcional) ---------- */
  function figuraMedidas() {
    var w = 8, L = 50 - 15 - w / 2, R = 50 + 15 + w / 2;
    var d = 'M50 6C46 6 44 9 44 13C44 17 45 19 46 21C40 22 34 23 32 27C30 32 32 40 34 46C36 52 37 56 37 60' +
      'C' + (37 - w * 0.3) + ' 66 ' + L + ' 72 ' + L + ' 80' +
      'C' + L + ' 92 ' + (L + 3) + ' 108 ' + (L + 6) + ' 124L49 124L50 98L51 124L' + (R - 6) + ' 124' +
      'C' + (R - 3) + ' 108 ' + R + ' 92 ' + R + ' 80' +
      'C' + R + ' 72 ' + (63 + w * 0.3) + ' 66 63 60C63 56 64 52 66 46C68 40 70 32 68 27C66 23 60 22 54 21C55 19 56 17 56 13C56 9 54 6 50 6Z';
    var linea = function (y, x1, x2, letra) {
      return '<path class="zft__zona" d="M' + x1 + ' ' + y + 'H' + x2 + '"/><text class="zft__letra" x="' + (x2 + 3) + '" y="' + (y + 2.5) + '">' + letra + '</text>';
    };
    return '<svg viewBox="24 2 60 124" aria-hidden="true"><path class="zft__silueta" d="' + d + '"/>' +
      linea(38, 30, 70, 'A') + linea(60, 34, 66, 'B') + linea(80, L - 4, R + 4, 'C') + '</svg>';
  }

  function pasoMedidas(cuerpo, pie) {
    var b = estado.borrador;
    var m = b.medidas || {};
    cuerpo.appendChild(contador(4));
    cuerpo.appendChild(h('p', { class: 'zft__intro', text: t('medidas_intro', 'Si tienes una cinta métrica, mide sobre ropa interior o ropa delgada, sin apretar. Es lo que más mejora la recomendación. Si no, puedes saltar este paso.') }));
    var opciones = function (desde, hasta) {
      return [{ valor: 0, texto: t('no_la_se', 'No la sé') }].concat(rango(desde, hasta, 1).map(function (v) { return { valor: v, texto: v + 'cm' }; }));
    };
    var campos = [
      ['pecho', 'A', t('medida_pecho', 'Busto'), t('como_pecho', 'Rodea la parte más llena del pecho, con la cinta recta en la espalda.'), 70, 140, 90],
      ['cintura', 'B', t('medida_cintura', 'Cintura'), t('como_cintura', 'Rodea la parte más estrecha, un poco arriba del ombligo.'), 50, 130, 72],
      ['cadera', 'C', t('medida_cadera', 'Cadera'), t('como_cadera', 'Rodea la parte más ancha de los glúteos, con los pies juntos.'), 75, 150, 98]
    ];
    var sels = {};
    var lista = h('div', { class: 'zft__medidas-campos' });
    campos.forEach(function (c) {
      var sel = selector('zft-m-' + c[0], c[2], opciones(c[4], c[5]), m[c[0]] != null ? m[c[0]] : null, c[6]);
      sels[c[0]] = sel;
      lista.appendChild(h('div', { class: 'zft__medida' }, [
        h('label', { for: 'zft-m-' + c[0], class: 'zft__label', text: c[1] + ' · ' + c[2] }),
        h('p', { class: 'zft__medida-nota', text: c[3] }),
        sel.wrap
      ]));
    });
    var imgMedidas = (config.imagenes || {}).medidas;
    var figura = imgMedidas
      ? h('div', { class: 'zft__medidas-fig' }, [h('img', { src: imgMedidas, alt: t('img_medidas_alt', 'Dónde medir el busto (A), la cintura (B) y la cadera (C)') })])
      : h('div', { class: 'zft__medidas-fig', html: figuraMedidas() });
    cuerpo.appendChild(h('div', { class: 'zft__medidas' }, [figura, lista]));

    function leer() {
      var nuevas = {};
      Object.keys(sels).forEach(function (k) { var v = sels[k].valor(); if (v) nuevas[k] = v; });
      b.medidas = nuevas;
    }
    pie.appendChild(h('button', { type: 'button', class: 'zft__btn zft__btn--sec', text: t('atras', 'Atrás'), onclick: function () { leer(); ir(2); } }));
    pie.appendChild(h('button', { type: 'button', class: 'zft__btn zft__btn--link', text: t('saltar', 'Saltar'), onclick: function () { b.medidas = {}; ir(4); } }));
    pie.appendChild(h('button', { type: 'button', class: 'zft__btn', text: t('continuar', 'Continuar'), onclick: function () { leer(); ir(4); } }));
  }

  /* ---------- Paso 4: cómo le gusta llevar la ropa ---------- */
  function pasoPreferencia(cuerpo, pie) {
    var b = estado.borrador;
    cuerpo.appendChild(contador(5));
    var opciones = [
      ['muy_ajustada', t('pref_muy_ajustada', 'Muy ajustada'), t('pref_muy_ajustada_txt', 'Pegada al cuerpo, marcando la silueta')],
      ['ajustada', t('pref_ajustada', 'Ajustada'), t('pref_ajustada_txt', 'Cerca del cuerpo, con poco espacio')],
      ['normal', t('pref_normal', 'Normal'), t('pref_normal_txt', 'Como fue diseñada la prenda')],
      ['holgada', t('pref_holgada', 'Holgada'), t('pref_holgada_txt', 'Con espacio para moverte con comodidad')],
      ['muy_holgada', t('pref_muy_holgada', 'Muy holgada'), t('pref_muy_holgada_txt', 'Amplia y suelta, sin marcar el cuerpo')]
    ];
    var lista = h('div', { class: 'zft__prefs', role: 'radiogroup', 'aria-label': t('titulo_paso_5', TITULOS_PASO[4]) });
    opciones.forEach(function (o) {
      lista.appendChild(h('button', {
        type: 'button', class: 'zft__pref', role: 'radio', 'aria-checked': b.preferencia === o[0] ? 'true' : 'false',
        onclick: function () { b.preferencia = o[0]; lista.querySelectorAll('.zft__pref').forEach(function (x) { x.setAttribute('aria-checked', 'false'); }); this.setAttribute('aria-checked', 'true'); }
      }, [h('span', { class: 'zft__pref-nombre', text: o[1] })]));
    });
    cuerpo.appendChild(h('div', { class: 'zft__grupo' }, [lista]));
    botones(pie, {
      atras: function () { ir(3); },
      texto: estado.modoPerfil ? t('guardar_perfil', 'Guardar mi perfil') : t('ver_talla', 'Ver mi talla recomendada'),
      siguiente: function () {
        var nuevo = !leerPerfil();
        guardarPerfil(estado.borrador);
        ir(RESULTADO);
        toast(nuevo ? t('perfil_creado', 'Tu perfil se guardó correctamente') : t('perfil_actualizado', 'Tu perfil se actualizó'));
      }
    });
  }

  /* ---------- Resultado ---------- */
  var NOMBRES_MEDIDA = { pecho: 'Busto', cintura: 'Cintura', cadera: 'Cadera' };

  /* "Tus datos": pares Etiqueta: valor, en dos columnas; "-" si no se llenó */
  function datosPerfil(p) {
    var u = p.unidades || {};
    var guion = '-';
    var alt = p.estatura ? (u.alt === 'in' ? Math.round(p.estatura / 2.54) + ' in' : Math.round(p.estatura) + ' cm') : guion;
    var peso = p.peso ? (u.peso === 'lb' ? Math.round(p.peso / 0.4536) + ' lb' : Math.round(p.peso) + ' kg') : guion;
    var formas = { plano: 'Plano', medio: 'Medio', abultado: 'Abultado', rectas: 'Rectas', medias: 'Medias', anchas: 'Anchas' };
    var prefs = { muy_ajustada: 'Muy ajustada', ajustada: 'Ajustada', normal: 'Normal', holgada: 'Holgada', muy_holgada: 'Muy holgada' };
    var hab = p.habitual || {};
    var talla = function (v) { return v && v !== 'nose' ? v : guion; };
    var med = p.medidas || {};
    var cm = function (v) { return Number(v) > 0 ? Math.round(v) + ' cm' : guion; };
    return [
      [t('estatura', 'Estatura'), alt],
      [t('peso', 'Peso'), peso],
      [t('edad', 'Edad'), p.edad ? p.edad + ' ' + t('anos', 'años') : guion],
      [t('abdomen_corto', 'Abdomen'), p.abdomen ? t('abdomen_' + p.abdomen, formas[p.abdomen]) : guion],
      [t('caderas_corto', 'Caderas'), p.caderas ? t('caderas_' + p.caderas, formas[p.caderas]) : guion],
      [t('habitual_blusa_corto', 'Talla en blusas'), talla(hab.blusa)],
      [t('habitual_pantalon_corto', 'Talla en pantalones'), talla(hab.pantalon)],
      [t('medida_pecho', 'Busto'), cm(med.pecho)],
      [t('medida_cintura', 'Cintura'), cm(med.cintura)],
      [t('medida_cadera', 'Cadera'), cm(med.cadera)],
      [t('corte', 'Corte'), p.preferencia ? t('pref_' + p.preferencia, prefs[p.preferencia]) : guion]
    ];
  }

  var NOMBRE_LARGO = { pecho: 'el busto', cintura: 'la cintura', cadera: 'la cadera' };
  function unirZonas(lista) {
    var z = lista.map(function (k) { return NOMBRE_LARGO[k]; });
    return z.length > 1 ? z.slice(0, -1).join(', ') + ' y ' + z[z.length - 1] : z[0];
  }

  /* Fila de medida: nombre · cómo le queda · (i) con las medidas (se abre con el mouse o con un toque) */
  function filaMedida(d, talla) {
    var FRASE = {
      ok: t('estado_ok', 'Te queda bien'),
      justa: t('estado_justa', 'Puede quedarte justa'),
      apretada: t('estado_apretada', 'Te quedará apretada'),
      suelta: t('estado_suelta', 'Te quedará suelta')
    };
    var ICONO = {
      ok: '<path d="M5 12l5 5L20 7"/>',
      justa: '<path d="M12 5v9M12 19h.01"/>',
      no: '<path d="M6 6l12 12M18 6L6 18"/>'
    };
    var clave = d.estado === 'no' ? d.tipo : d.estado;
    var info = h('span', { class: 'zft__info' });
    var boton = h('button', { type: 'button', class: 'zft__i', 'aria-expanded': 'false', 'aria-label': t('ver_medidas', 'Ver medidas de [medida]').replace('[medida]', t('medida_' + d.medida, NOMBRES_MEDIDA[d.medida]).toLowerCase()), text: 'i' });
    var cuadro = h('span', { class: 'zft__pop', role: 'tooltip' }, [
      h('span', { class: 'zft__pop-fila' }, [h('span', { text: t('col_cuerpo', 'Tu cuerpo') }), h('b', { text: d.cuerpo + ' cm' })]),
      h('span', { class: 'zft__pop-nota', text: d.medido ? t('tag_tuya_larga', 'La escribiste tú') : t('tag_calculada_larga', 'Calculada con tus respuestas') }),
      h('span', { class: 'zft__pop-fila' }, [h('span', { text: t('col_talla', 'Cuerpo para la talla [talla]').replace('[talla]', talla) }), h('b', { text: d.rango[0] + '–' + d.rango[1] + ' cm' })])
    ]);
    boton.addEventListener('click', function (e) {
      e.stopPropagation();
      var abierto = info.classList.toggle('is-abierto');
      boton.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      dlg.querySelectorAll('.zft__info.is-abierto').forEach(function (x) {
        if (x !== info) { x.classList.remove('is-abierto'); x.querySelector('.zft__i').setAttribute('aria-expanded', 'false'); }
      });
    });
    info.appendChild(boton);
    info.appendChild(cuadro);
    return h('div', { class: 'zft__med' }, [
      h('span', { class: 'zft__med-nombre', text: t('medida_' + d.medida, NOMBRES_MEDIDA[d.medida]) }),
      h('span', { class: 'zft__med-estado zft__med-estado--' + d.estado }, [
        h('span', { class: 'zft__med-icono', html: '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICONO[d.estado] + '</svg>' }),
        h('span', { text: FRASE[clave] }),
        info
      ])
    ]);
  }

  function pasoResultado(cuerpo, pie) {
    var perfil = leerPerfil();
    if (!perfil) return ir(0);
    if (estado.modoPerfil) return resultadoPerfil(cuerpo, pie, perfil);
    var p = estado.producto;
    if (p === null) {
      cuerpo.appendChild(h('div', { class: 'zft__cargando' }, [h('span', { class: 'zft__spin', 'aria-hidden': 'true' }), h('span', { text: t('cargando', 'Calculando tu talla...') })]));
      return;
    }
    var ficha = (p && p.ficha) || (estado.contexto && estado.contexto.ficha) || null;
    var res = null;
    if (ficha) {
      var clave = estado.handle + '|' + clavePerfil(perfil);
      if (estado.recClave !== clave) {
        estado.recClave = clave;
        estado.rec = undefined;
        pedirMotor(perfil, [], estado.handle, estado.contexto && estado.contexto.esPagina ? 'producto' : 'tarjeta').then(function (d) {
          if (!estado || estado.recClave !== clave) return;
          if (d.registro) guardarRegistro(estado.handle, d.registro);
          estado.rec = d.detalle || null;
          estado.recMotivo = d.motivo || '';
          if (estado.paso === RESULTADO) pintar();
        }).catch(function (e) {
          console.warn('[Encuentra tu talla] El servidor no respondió:', e && e.message);
          if (!estado || estado.recClave !== clave) return;
          estado.rec = false;
          if (estado.paso === RESULTADO) pintar();
        });
      }
      if (estado.rec === undefined) {
        cuerpo.appendChild(h('div', { class: 'zft__cargando' }, [h('span', { class: 'zft__spin', 'aria-hidden': 'true' }), h('span', { text: t('cargando', 'Calculando tu talla...') })]));
        return;
      }
      if (estado.rec === false) return sinServidor(cuerpo, pie, p);
      res = estado.rec;
    }
    if (!res) console.warn('[Encuentra tu talla] Sin recomendación para "' + estado.handle + '": ' + (p === false && !ficha ? 'no se pudieron leer los datos del producto' : MOTIVOS[estado.recMotivo] || MOTIVOS.sin_ficha));

    /* La prenda */
    if (p && (p.title || p.image)) {
      cuerpo.appendChild(h('div', { class: 'zft__prod' }, [
        p.image ? h('img', { src: p.image, alt: '', class: 'zft__prod-foto' }) : null,
        p.title ? h('p', { class: 'zft__prod-nombre', text: p.title }) : null
      ]));
    }

    /* Talla que se muestra y talla a agregar (puede cambiar si la recomendada está agotada) */
    var tallaMostrada = res ? (res.talla || res.cercana) : null;
    var agregarTalla = tallaMostrada, agregarVar = null, agotada = false, reemplazo = null;
    if (res && tallaMostrada) {
      agregarVar = varianteParaTalla(p, tallaMostrada, estado.contexto);
      if (agregarVar && agregarVar.available === false) {
        agotada = true;
        (res.otras || []).some(function (o) {
          var v = varianteParaTalla(p, o.talla, estado.contexto);
          if (v && v.available !== false) { reemplazo = { talla: o.talla, mayor: o.mayor, variante: v }; return true; }
          return false;
        });
      }
    }

    /* La talla primero, en grande; los avisos en un recuadro con borde (sin verde ni rojo) */
    if (res) {
      cuerpo.appendChild(h('p', { class: 'zft__eti', text: res.noEntra ? t('talla_cercana_titulo', 'La talla más cercana') : t('talla_recomendada', 'Tu talla recomendada') }));
      cuerpo.appendChild(h('p', { class: 'zft__grande', text: tallaMostrada }));
      if (res.noEntra) {
        var pr = res.problema;
        var txt = pr.tipo === 'suelta'
          ? t('cercana_suelta', '*Ninguna talla te queda del todo. Esta te quedará suelta en [medida] (unos [n] cm).')
          : t('cercana_apretada', '*Ninguna talla te queda del todo. Esta te quedará apretada en [medida] (unos [n] cm).');
        cuerpo.appendChild(h('p', { class: 'zft__aviso', text: txt.replace(/^\*\s*/, '').replace('[medida]', NOMBRE_LARGO[pr.medida]).replace('[n]', pr.exceso) }));
      } else {
        cuerpo.appendChild(h('p', { class: 'zft__resumen', text: res.estado === 'justa'
          ? t('msg_justa', 'Te podría quedar justa en [zonas].').replace('[zonas]', unirZonas(res.justas))
          : t('msg_bien', 'Te queda bien en las medidas que importan para esta prenda.') }));
        if (agotada) {
          cuerpo.appendChild(h('p', { class: 'zft__aviso', text: reemplazo
            ? (reemplazo.mayor
              ? t('agotada_mayor', 'La [talla] está agotada, pero la [otra] también te queda, un poco más holgada.')
              : t('agotada_menor', 'La [talla] está agotada, pero la [otra] también te queda, un poco más ajustada.')).replace('[talla]', res.talla).replace('[otra]', reemplazo.talla)
            : t('agotada_sin', 'La [talla] está agotada por ahora.').replace('[talla]', res.talla) }));
        } else if (res.alternativa) {
          cuerpo.appendChild(h('p', { class: 'zft__resumen zft__resumen--sec', text: (res.alternativaMayor
            ? t('alt_mayor', 'Si la prefieres más holgada, prueba la [talla].')
            : t('alt_menor', 'Si la prefieres más ajustada, prueba la [talla].')).split('[talla]').join(res.alternativa) }));
        }
      }
    } else {
      if (p && p.title) cuerpo.appendChild(h('p', { class: 'zft__eti', text: t('tu_talla_titulo', 'Tu talla') }));
      cuerpo.appendChild(h('p', { class: 'zft__aviso', text: p === false && !ficha
        ? t('error_carga', 'No pudimos cargar las medidas de esta prenda. Revisa tu conexión e inténtalo de nuevo.')
        : estado.recMotivo === 'ficha_incompleta'
          ? t('ficha_incompleta', 'Aún no tenemos las medidas de todas las tallas de esta prenda. Revisa la Guía de medidas; tu perfil quedó guardado para las demás.')
          : t('sin_ficha', 'Esta prenda aún no tiene medidas para recomendarte una talla. Tu perfil quedó guardado para las demás.') }));
    }

    /* Ajuste por zona: riel con el rango de la talla y el punto de tu medida */
    if (res && res.detalle.length) {
      var zonas = h('div', { class: 'zft__zonas' }, [
        h('p', { class: 'zft__zonas-nota', text: t('zonas_nota', 'Cómo te queda la talla [talla] en cada zona:').replace('[talla]', tallaMostrada) })
      ]);
      res.detalle.forEach(function (d) { zonas.appendChild(zonaRiel(d, tallaMostrada)); });
      cuerpo.appendChild(zonas);
      if (res.detalle.some(function (d) { return !d.medido; })) {
        var irMedidas = h('button', { type: 'button', class: 'zft__link', text: t('precision_link', 'tus medidas') });
        irMedidas.addEventListener('click', function () { estado.borrador = JSON.parse(JSON.stringify(perfil)); ir(3); });
        cuerpo.appendChild(h('p', { class: 'zft__precision' }, [
          t('precision_corta', 'Para afinarla, agrega') + ' ', irMedidas, '.'
        ]));
      }
    }

    cuerpo.appendChild(perfilCompacto(cuerpo, pie, perfil));

    /* Botones: la acción principal a todo el ancho; "de todas formas" en blanco para que no parezca la recomendada */
    if (res && agregarTalla) {
      var disponible = agregarVar && agregarVar.available !== false;
      if (!agregarVar) {
        pie.appendChild(h('button', { type: 'button', class: 'zft__btn zft__btn--ancho', disabled: true,
          text: t('sin_variante', 'Elige la talla [talla] en la página del producto').split('[talla]').join(agregarTalla) }));
      } else if (agotada) {
        /* Sin acción por ahora: se conectará con la app de aviso de stock (data-zft-avisame lleva producto y talla) */
        pie.appendChild(h('button', {
          type: 'button', class: 'zft__btn' + (reemplazo ? ' zft__btn--blanco' : ' zft__btn--ancho'),
          text: reemplazo ? t('avisame_talla', 'Avísame de la [talla]').replace('[talla]', agregarTalla) : t('avisame', 'Avísame cuando esté disponible'),
          'data-zft-avisame': '', 'data-producto': estado.handle, 'data-talla': agregarTalla, 'data-variante': agregarVar.id
        }));
        if (reemplazo) {
          var btnOtra = h('button', { type: 'button', class: 'zft__btn', text: t('agregar_otra', 'Añadir la [talla]').replace('[talla]', reemplazo.talla) });
          btnOtra.addEventListener('click', function () { agregar(btnOtra, reemplazo.variante, reemplazo.talla); });
          pie.appendChild(btnOtra);
        }
      } else {
        var texto = res.noEntra
          ? t('agregar_igual', 'Añadir la [talla] de todas formas').split('[talla]').join(agregarTalla)
          : t('agregar', 'Añadir talla [talla] al carrito').split('[talla]').join(agregarTalla);
        var btn = h('button', { type: 'button', class: 'zft__btn zft__btn--ancho' + (res.noEntra ? ' zft__btn--blanco' : ''), text: texto, disabled: !disponible });
        btn.addEventListener('click', function () { agregar(btn, agregarVar, agregarTalla); });
        pie.appendChild(btn);
      }
    } else {
      pie.appendChild(h('button', { type: 'button', class: 'zft__btn zft__btn--ancho', text: t('cerrar', 'Cerrar'), onclick: cerrar }));
    }
  }

  /* Una zona del resultado (opción B, votada por el equipo): ícono, nombre de la zona y cómo te queda.
     ✓ te queda bien · flechas hacia adentro: apretada o justa · flechas hacia afuera: holgada.
     Si no queda bien, debajo se dice cuánto falta o sobra; al tocar la fila se ven los centímetros. */
  var ICONOS_ZONA = {
    bien: 'M5 12.5l4.5 4.5L19 7.5',
    apretada: 'M1.5 12h8M6 7.5L10.5 12 6 16.5M22.5 12h-8M18 7.5L13.5 12l4.5 4.5',
    holgada: 'M10 12H1.5M6 7.5L1.5 12 6 16.5M14 12h8.5M18 7.5l4.5 4.5-4.5 4.5'
  };
  function zonaRiel(d, talla) {
    var FRASE = {
      ok: t('estado_ok', 'Te queda bien'),
      justa: t('estado_justa', 'Puede quedarte justa'),
      apretada: t('estado_apretada', 'Te quedará apretada'),
      suelta: t('estado_suelta', 'Te quedará suelta')
    };
    var clave = d.estado === 'no' ? d.tipo : d.estado;
    var a = Number(d.rango[0]), b = Number(d.rango[1]), c = Number(d.cuerpo);
    var icono = clave === 'ok' ? 'bien' : clave === 'suelta' ? 'holgada' : 'apretada';
    var mal = clave !== 'ok';
    var nombre = t('medida_' + d.medida, NOMBRES_MEDIDA[d.medida]);
    var hijos = [
      h('span', { class: 'zft__zb-ico', 'aria-hidden': 'true', html: '<svg viewBox="0 0 24 24"><path d="' + ICONOS_ZONA[icono] + '"/></svg>' }),
      h('span', { class: 'zft__zb-n', text: nombre }),
      h('span', { class: 'zft__zb-f', text: FRASE[clave] })
    ];
    var diferencia = null;
    if (clave === 'apretada' && c > b) diferencia = t('det_falta', 'A la prenda le faltan unos [n] cm en [medida].').replace('[n]', Math.max(1, Math.round(c - b)));
    else if (clave === 'suelta' && c < a) diferencia = t('det_sobra', 'A la prenda le sobran unos [n] cm en [medida].').replace('[n]', Math.max(1, Math.round(a - c)));
    else if (clave === 'justa') diferencia = t('det_justa', 'Te queda, pero cerca del límite de la talla en [medida].');
    if (diferencia) hijos.push(h('span', { class: 'zft__zb-d', text: diferencia.replace('[medida]', NOMBRE_LARGO[d.medida] || nombre.toLowerCase()) }));
    var detalle = h('span', { class: 'zft__zb-d zft__zb-cm', hidden: true,
      text: t('det_tu_medida', 'Tu medida') + ': ' + Math.round(c) + ' cm (' + (d.medido ? t('tag_tuya_larga', 'La escribiste tú') : t('tag_calculada_larga', 'Calculada con tus respuestas')).toLowerCase() + ') · ' +
        t('det_talla', 'La talla [talla] es para').replace('[talla]', talla) + ' ' + a + '–' + b + ' cm' });
    hijos.push(detalle);
    var fila = h('button', { type: 'button', class: 'zft__zb' + (mal ? ' zft__zb--mal' : ''), 'aria-expanded': 'false' }, hijos);
    fila.addEventListener('click', function () {
      detalle.hidden = !detalle.hidden;
      fila.setAttribute('aria-expanded', detalle.hidden ? 'false' : 'true');
    });
    return fila;
  }

  /* Tu perfil en una línea (dónde está guardado y cuándo), con editar y borrar; si solo está en este
     dispositivo y hay cuenta de clientes, un recuadro para iniciar sesión */
  var MESES_CORTOS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sept', 'oct', 'nov', 'dic'];
  function fechaCorta(ts) {
    var d = new Date(Number(ts));
    if (isNaN(d.getTime())) return '';
    return d.getDate() + ' ' + MESES_CORTOS[d.getMonth()] + (d.getFullYear() !== new Date().getFullYear() ? ' de ' + d.getFullYear() : '');
  }
  function botonIcono(etiqueta, trazo, accion) {
    return h('button', { type: 'button', class: 'zft__ico', 'aria-label': etiqueta, title: etiqueta, onclick: accion,
      html: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + trazo + '"/></svg>' });
  }
  function perfilCompacto(cuerpo, pie, perfil) {
    var cuenta = window.ZendelayaCuenta;
    var activa = !!(cuenta && cuenta.activo);
    var enCuenta = !!(activa && cuenta.conSesion && cuenta.conSesion());
    var donde = enCuenta ? t('perfil_en_cuenta', 'Guardado en tu cuenta')
      : activa ? t('perfil_solo_dispositivo', 'Solo en este dispositivo') : t('perfil_en_dispositivo', 'Guardado en este dispositivo');
    var f = perfil.actualizado ? fechaCorta(perfil.actualizado) : '';
    var caja = h('div', { class: 'zft__perfilc-caja' }, [
      h('div', { class: 'zft__perfilc' }, [
        h('div', { class: 'zft__perfilc-txt' }, [
          h('p', { class: 'zft__eti zft__eti--pegada', text: t('tu_perfil', 'Tu perfil') }),
          h('p', { text: donde + (f ? ' · ' + f : '') })
        ]),
        h('div', { class: 'zft__perfilc-acc' }, [
          botonIcono(t('editar_perfil', 'Editar tu perfil'), 'M4 20h4L19 9l-4-4L4 16v4z M13.5 6.5l4 4', function () {
            estado.borrador = JSON.parse(JSON.stringify(perfil)); ir(0);
          }),
          botonIcono(t('borrar_perfil', 'Borrar tu perfil'), 'M4 7h16M9.5 7V4.5h5V7M6 7l1 13h10l1-13M10 11v5.5M14 11v5.5', function () {
            confirmarBorrado(cuerpo, pie);
          })
        ])
      ])
    ]);
    if (activa && !enCuenta) {
      var tx = cuenta.textos || {};
      caja.appendChild(h('div', { class: 'zft__cuenta' }, [
        h('span', { text: t('cuenta_invitar', 'Guárdalo en tu cuenta y úsalo en cualquier dispositivo.') }),
        h('a', { class: 'zft__btn zft__btn--blanco zft__btn--chico', href: cuenta.loginUrl, text: tx.iniciar || t('iniciar_sesion', 'Iniciar sesión') })
      ]));
    }
    return caja;
  }

  /* Modo perfil: confirmación y resumen de los datos, sin prenda */
  function resultadoPerfil(cuerpo, pie, perfil) {
    cuerpo.appendChild(h('div', { class: 'zft__encabezado' }, [
      h('h2', { class: 'zft__titulo-paso', text: t('perfil_listo', 'Tu perfil está listo') })
    ]));
    cuerpo.appendChild(h('p', { class: 'zft__intro', text: t('perfil_listo_texto', 'Verás tu talla recomendada en cada prenda que tenga medidas.') }));
    cuerpo.appendChild(bloquePerfil(cuerpo, pie, perfil));
    pie.appendChild(h('button', { type: 'button', class: 'zft__btn zft__btn--ancho', text: t('cerrar', 'Cerrar'), onclick: cerrar }));
  }

  function bloquePerfil(cuerpo, pie, perfil) {
    var cuenta = window.ZendelayaCuenta;
    var activa = !!(cuenta && cuenta.activo);
    var enCuenta = !!(activa && cuenta.conSesion && cuenta.conSesion());
    var caja = h('div', { class: 'zft__perfil' }, [
      h('div', { class: 'zft__perfil-cab' }, [
        h('p', { class: 'zft__label', text: t('tus_datos', 'Tus datos') }),
        h('div', { class: 'zft__perfilc-acc' }, [
          botonIcono(t('editar_perfil', 'Editar tu perfil'), 'M4 20h4L19 9l-4-4L4 16v4z M13.5 6.5l4 4', function () {
            estado.borrador = JSON.parse(JSON.stringify(perfil)); ir(0);
          }),
          botonIcono(t('borrar_perfil', 'Borrar tu perfil'), 'M4 7h16M9.5 7V4.5h5V7M6 7l1 13h10l1-13M10 11v5.5M14 11v5.5', function () {
            confirmarBorrado(cuerpo, pie);
          })
        ])
      ]),
      h('div', { class: 'zft__datos' }, datosPerfil(perfil).map(function (d) {
        return h('p', { class: 'zft__dato' }, [h('span', { class: 'zft__dato-k', text: d[0] + ':' }), ' ' + d[1]]);
      }))
    ]);
    if (activa && !enCuenta) {
      var tx = cuenta.textos || {};
      caja.appendChild(h('div', { class: 'zft__cuenta' }, [
        h('span', { text: t('cuenta_invitar', 'Guárdalo en tu cuenta y úsalo en cualquier dispositivo.') }),
        h('a', { class: 'zft__btn zft__btn--blanco zft__btn--chico', href: cuenta.loginUrl, text: tx.iniciar || t('iniciar_sesion', 'Iniciar sesión') })
      ]));
    } else if (enCuenta) {
      caja.appendChild(h('p', { class: 'zft__legal', text: (cuenta.textos || {}).talla_guardado || t('perfil_en_cuenta_largo', 'Tu perfil está guardado en tu cuenta.') }));
    }
    return caja;
  }

  /* El servidor no respondió: reintentar o elegir con la Guía de medidas */
  function sinServidor(cuerpo, pie, p) {
    cuerpo.appendChild(h('p', { class: 'zft__intro', text: t('error_motor', 'No pudimos calcular tu talla en este momento. Puedes intentarlo de nuevo o elegirla con la Guía de medidas de la prenda.') }));
    var guia = document.querySelector('[data-zd-gm-open]');
    if (guia && estado.contexto && estado.contexto.esPagina) {
      pie.appendChild(h('button', { type: 'button', class: 'zft__btn zft__btn--sec', text: t('ver_guia', 'Ver la guía de medidas'), onclick: function () { cerrar(); guia.click(); } }));
    } else if (p && p.url) {
      pie.appendChild(h('a', { class: 'zft__btn zft__btn--sec', href: p.url, text: t('ver_guia', 'Ver la guía de medidas') }));
    }
    pie.appendChild(h('button', { type: 'button', class: 'zft__btn', text: t('reintentar', 'Intentar de nuevo'), onclick: function () { estado.recClave = null; pintar(); } }));
  }

  /* Debajo de "Tus datos": dónde quedó guardado el perfil */
  function notaCuenta() {
    var cuenta = window.ZendelayaCuenta;
    if (!cuenta || !cuenta.activo) return null;
    var tx = cuenta.textos || {};
    if (!cuenta.conSesion()) {
      return h('p', { class: 'zft__legal' }, [
        h('a', { href: cuenta.loginUrl, text: tx.iniciar || 'Inicia sesión' }),
        ' ' + (tx.talla_invitado || 'para guardar tu perfil en tu cuenta y verlo en cualquier dispositivo.')
      ]);
    }
    return h('p', { class: 'zft__legal', text: tx.talla_guardado || 'Tu perfil está guardado en tu cuenta.' });
  }

  function confirmarBorrado(cuerpo, pie) {
    cuerpo.innerHTML = '';
    pie.innerHTML = '';
    cuerpo.appendChild(h('p', { class: 'zft__intro', text: t('borrar_pregunta', '¿Borrar tus datos? Dejaremos de recomendarte tallas hasta que vuelvas a llenarlos.') }));
    pie.appendChild(h('button', { type: 'button', class: 'zft__btn zft__btn--sec', text: t('cancelar', 'Cancelar'), onclick: function () { pintar(); } }));
    pie.appendChild(h('button', {
      type: 'button', class: 'zft__btn', text: t('borrar_si', 'Sí, borrar'),
      onclick: function () {
        borrarPerfil();
        estado.borrador = { unidades: { alt: 'cm', peso: 'kg' }, sujetador: null, preferencia: 'normal' };
        ir(0);
        toast(t('perfil_borrado', 'Tus datos se borraron'));
      }
    }));
  }

  function agregar(btn, variante, talla) {
    if (!variante || btn.disabled) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = t('agregando', 'Agregando...');
    var carrito = window.ZendelayaCart
      ? Promise.resolve(window.ZendelayaCart)
      : new Promise(function (ok, no) {
          var tm = setTimeout(function () { no(new Error('carrito')); }, 8000);
          document.addEventListener('zendelaya:cart-ready', function () { clearTimeout(tm); ok(window.ZendelayaCart); }, { once: true });
        });
    carrito.then(function (c) {
      return c.addToCart([{ id: variante.id, quantity: 1 }], { source: btn, sourceName: 'zendelaya-talla' });
    }).then(function () {
      btn.textContent = '✓ ' + t('agregada', 'Talla [talla] agregada').split('[talla]').join(talla);
      setTimeout(function () { cerrar(); btn.textContent = original; btn.disabled = false; }, 1100);
    }).catch(function (err) {
      btn.textContent = (err && err.userMessage) || t('error_carrito', 'No se pudo agregar. Intenta de nuevo.');
      setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 2500);
    });
  }

  /* ------------------------------------------------------------------ Estilos */
  function inyectarEstilos() {
    if (document.getElementById('zft-estilos')) return;
    var css = [
      'html.zft-abierta{overflow:hidden}',
      '.zft{background:#fff;color:var(--zd-tinta,#242122)}',
      '.zft::backdrop{background:rgb(36 33 34/.4)}',
      '.zft__box{position:relative;display:flex;flex-direction:column;height:100%;box-sizing:border-box}',
      '.zft__head{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:20px 24px;border-bottom:1px solid var(--zd-linea,#e5e5e5)}',
      '.zft__titulo{margin:0;font-size:var(--zd-t-panel,20px);font-weight:600;line-height:1.25;letter-spacing:-.01em;text-transform:none}',
      '.zft__x{display:flex;align-items:center;justify-content:center;width:36px;height:36px;padding:0;border:0;border-radius:50%;background:transparent;color:var(--zd-tinta,#242122);cursor:pointer}',
      /* Un solo cuadrado: sin el contorno de foco del tema (al abrir, el navegador enfoca la X) */
      '.zft__x,.zft__x:focus,.zft__x:focus-visible{outline:none!important;box-shadow:none!important}',
      '.zft__x::before,.zft__x::after{display:none!important}',
      '.zft__x:hover{background:var(--zd-suave,#f5f5f5)}.zft__x:focus-visible{background:var(--zd-suave,#f5f5f5)}',
      '.zft__progreso{height:2px;margin:0;background:var(--zd-linea,#e5e5e5)}',
      '.zft__progreso span{display:block;height:100%;width:0;background:var(--zd-tinta,#242122);transition:width .3s ease}',
      '.zft__cuerpo{flex:1;overflow-y:auto;overscroll-behavior:contain;padding:20px 24px 8px}',
      '.zft__pie{display:flex;flex-wrap:wrap;gap:10px;padding:16px 24px calc(20px + env(safe-area-inset-bottom,0px));border-top:1px solid var(--zd-linea,#e5e5e5)}' + '.zft__pie>.zft__btn{flex:1 1 0}.zft__pie>.zft__btn--sec{flex:0 0 33%;margin-right:0}.zft__pie>.zft__btn--link{flex:0 0 auto}.zft__pie>.zft__btn--ancho,.zft__pie>.zft__btn--fila{flex:1 1 100%}',
      '.zft__paso{margin:0 0 6px;font-size:12px;letter-spacing:.06em;text-transform:uppercase;opacity:.6}',
      '.zft__intro{margin:0 0 18px;font-size:14px;line-height:1.5}',
      '.zft__campo{display:grid;grid-template-columns:110px 1fr;align-items:center;gap:12px;margin-bottom:14px}',
      '.zft__label{margin:0 0 8px;font-size:13px;font-weight:600}',
      '.zft__campo .zft__label{margin:0}',
      '.zft__control{display:flex;align-items:stretch;gap:8px}',
      '.zft__control input{flex:1;min-width:0;height:44px;padding:0 12px;border:1px solid rgb(0 0 0/.3);border-radius:0;background:#fff;color:inherit;font:inherit;font-size:15px;box-sizing:border-box}',
      '.zft__control input:focus{outline:2px solid var(--zd-tinta,#242122);outline-offset:-1px}',
      '.zft__unidades{display:flex}',
      '.zft__unidad{min-width:44px;height:44px;padding:0 8px;border:1px solid rgb(0 0 0/.3);border-radius:0;background:#fff;color:inherit;font:inherit;font-size:13px;cursor:pointer}',
      '.zft__unidad+.zft__unidad{border-left:0}',
      '.zft__unidad[aria-pressed="true"]{background:var(--zd-tinta,#242122);border-color:var(--zd-tinta,#242122);color:#fff}',
      '.zft__unidades--vacio{visibility:hidden}',
      '.zft__encabezado{margin-bottom:14px}',
      '.zft__titulo-paso{margin:0;font-size:18px;font-weight:600;line-height:1.3}',
      '.zft__select{position:relative;flex:1;min-width:0}',
      '.zft__select-btn{display:flex;align-items:center;justify-content:space-between;gap:8px;width:100%;height:44px;padding:0 12px;border:1px solid rgb(0 0 0/.3);border-radius:0;background:#fff;color:inherit;font:inherit;font-size:15px;text-align:left;cursor:pointer;box-sizing:border-box}',
      '.zft__select-btn[aria-expanded="true"]{border-color:var(--zd-tinta,#242122)}',
      '.zft__select-btn:focus-visible{outline:2px solid var(--zd-tinta,#242122);outline-offset:-1px}',
      '.zft__select-valor.is-vacio{opacity:.5}',
      '.zft__select-flecha{display:flex;transition:transform .2s ease}',
      '.zft__select-btn[aria-expanded="true"] .zft__select-flecha{transform:rotate(180deg)}',
      '.zft__opciones{position:absolute;left:0;right:0;top:calc(100% - 1px);z-index:5;max-height:220px;margin:0;padding:4px 0;overflow-y:auto;overscroll-behavior:contain;list-style:none;background:#fff;border:1px solid var(--zd-tinta,#242122);box-shadow:0 8px 20px rgb(0 0 0/.12);box-sizing:border-box}',
      '.zft__opciones:focus{outline:none}',
      '.zft__opciones li{padding:9px 12px;font-size:14px;cursor:pointer}',
      '.zft__opciones li:hover,.zft__opciones li.is-activo{background:rgb(0 0 0/.06)}',
      '.zft__opciones li[aria-selected="true"]{font-weight:600}',
      '.zft__campo--nota{grid-template-areas:". nota" "label control"}',
      '.zft__campo--nota .zft__campo-nota{grid-area:nota}',
      '.zft__campo--nota .zft__label{grid-area:label}',
      '.zft__campo--nota .zft__control{grid-area:control}',
      '.zft__campo-nota{margin:0;font-size:12px;line-height:1.45;opacity:.7}',
      '.zft__pref-nombre{font-weight:400}',
      '.zft__pref-txt{font-size:12px;opacity:.7}',
      '.zft__chip--ancho{padding:0 14px}',
      '.zft__medidas{display:grid;grid-template-columns:minmax(0,40%) minmax(0,1fr);gap:16px;align-items:start}',
      '.zft__medidas-fig{position:sticky;top:0}.zft__medidas-fig svg,.zft__medidas-fig img{display:block;width:100%;height:auto;max-height:420px;object-fit:contain;object-position:top center}',
      '.zft__letra{font-size:7px;fill:var(--zd-tinta,#242122);font-family:inherit}',
      '.zft__medida{margin-bottom:14px}',
      '.zft__medida .zft__label{margin:0 0 2px}',
      '.zft__medida-nota{margin:0 0 6px;font-size:12px;line-height:1.4;opacity:.7}',
      '.zft__noentra{margin:4px 0 8px;font-size:20px;line-height:1.25}',
      '.zft__datos{display:grid;grid-template-columns:1fr 1fr;gap:6px 16px;margin:0 0 12px}',
      '.zft__dato{margin:0;font-size:13px;line-height:1.4}',
      '.zft__dato-k{opacity:.65}',
      '.zft__error{min-height:1.2em;margin:4px 0 8px;font-size:13px;color:#b3261e}',
      '.zft__legal{margin:8px 0 0;font-size:12px;line-height:1.5;opacity:.75}',
      '.zft__legal a{color:inherit;text-decoration:underline;text-underline-offset:3px}',
      '.zft__grupo{margin-bottom:20px}',
      '.zft__formas{display:grid;grid-template-columns:repeat(3,1fr);gap:10px}',
      '.zft__forma{display:flex;flex-direction:column;align-items:center;gap:8px;padding:10px 6px;border:1px solid rgb(0 0 0/.15);border-radius:0;background:#fff;color:inherit;font:inherit;font-size:13px;cursor:pointer}',
      '.zft__forma[aria-checked="true"]{border-color:var(--zd-tinta,#242122);box-shadow:inset 0 0 0 1px var(--zd-tinta,#242122)}',
      '.zft__forma-img{display:flex;align-items:center;justify-content:center;width:100%;height:120px}',
      '.zft__forma-img svg,.zft__forma-img img{height:100%;width:auto;max-width:100%;object-fit:contain}',
      '.zft__silueta{fill:#d9d9d9}',
      '.zft__zona{fill:none;stroke:var(--zd-tinta,#242122);stroke-width:1.2;stroke-dasharray:3 2}',
      '.zft__tabs{display:flex;flex-wrap:wrap;gap:4px 18px}',
      '.zft__tab{padding:4px 0;border:0;border-bottom:1px solid transparent;border-radius:0;background:none;color:inherit;font:inherit;font-size:13px;opacity:.55;cursor:pointer}',
      '.zft__tab[aria-selected="true"]{opacity:1;border-bottom-color:currentColor}',
      '.zft__chips{display:flex;flex-wrap:wrap;gap:2px}',
      '.zft__chip{min-width:44px;height:44px;padding:0 6px;border:0;border-radius:0;background:transparent;color:var(--zd-gris,#6b6b6b);font:inherit;font-size:14px;cursor:pointer}.zft__chip:hover{color:var(--zd-tinta,#242122)}',
      '.zft__chip[aria-checked="true"]{color:var(--zd-tinta,#242122);font-weight:600;box-shadow:inset 0 -2px 0 var(--zd-tinta,#242122)}',
      '.zft__prefs{display:flex;flex-direction:column;gap:8px}',
      '.zft__pref{display:flex;flex-direction:column;align-items:flex-start;justify-content:center;gap:2px;min-height:48px;padding:8px 14px;border:1px solid rgb(0 0 0/.15);border-radius:0;background:#fff;color:inherit;font:inherit;font-size:14px;text-align:left;cursor:pointer}',
      '.zft__pref[aria-checked="true"]{border-color:var(--zd-tinta,#242122);box-shadow:inset 0 0 0 1px var(--zd-tinta,#242122)}',
      '.zft__btn{min-height:44px;padding:0 18px;border:1px solid var(--zd-tinta,#242122);border-radius:0;background:var(--zd-tinta,#242122);color:#fff;font:inherit;font-size:var(--zd-t-boton,12px);font-weight:600;letter-spacing:.14em;text-transform:uppercase;cursor:pointer}',
      '.zft__btn:disabled{opacity:.45;cursor:not-allowed}',
      '.zft__btn--sec{background:#fff;color:var(--zd-tinta,#242122);margin-right:auto}',
      '.zft__btn--link{border-color:transparent;background:none;color:var(--zd-tinta,#242122);text-decoration:underline;text-underline-offset:3px;padding:0 10px}',
      '.zft__btn--ancho{flex:1}',
      '.zft__res{display:grid;grid-template-columns:120px 1fr;gap:18px;align-items:start}',
      '.zft__res:not(:has(.zft__foto)){grid-template-columns:1fr}',
      '.zft__foto{width:100%;aspect-ratio:3/4;object-fit:cover;background:rgb(0 0 0/.04)}',
      '.zft__producto{margin:0 0 10px;font-size:13px;opacity:.75}',
      '.zft__reclabel{margin:0;font-size:12px;letter-spacing:.06em;text-transform:uppercase}',
      '.zft__talla{margin:0 0 6px;font-size:34px;font-weight:600;line-height:1.1}',
      '.zft__precision{margin:10px 0 0;font-size:12px;opacity:.8}',
      '.zft__precision .zft__link,.zft__link--msg{font-size:inherit}',
      '.zft__btn--fila{flex:1 1 100%}',
      '.zft__btn--blanco{background:#fff;color:var(--zd-tinta,#242122)}',
      '.zft__talla-nota{margin-left:8px;font-size:12px;font-weight:400;opacity:.65}',
      '.zft__meds{margin-top:16px;border-top:1px solid rgb(0 0 0/.08)}',
      '.zft__med{display:flex;align-items:center;justify-content:space-between;gap:12px;padding:10px 0;border-bottom:1px solid rgb(0 0 0/.08);font-size:13px}',
      '.zft__med-estado{display:inline-flex;align-items:center;gap:6px;text-align:right}',
      '.zft__med-icono{display:inline-flex}',
      '.zft__med-estado--ok{color:#2f6b1f}',
      '.zft__med-estado--justa{color:#8a5a00}',
      '.zft__med-estado--no{color:#b3261e}',
      '.zft__info{position:relative;display:inline-flex}',
      '.zft__i{display:inline-flex;align-items:center;justify-content:center;width:18px;height:18px;padding:0;border:1px solid rgb(0 0 0/.35);border-radius:50%;background:#fff;color:#5f5e5a;font:inherit;font-size:11px;font-style:italic;line-height:1;cursor:pointer}',
      '.zft__pop{position:absolute;right:0;top:calc(100% + 6px);z-index:3;display:none;flex-direction:column;gap:4px;width:220px;padding:10px 12px;background:#fff;border:1px solid var(--zd-tinta,#242122);box-shadow:0 6px 18px rgb(0 0 0/.12);color:var(--zd-tinta,#242122);font-size:12px;text-align:left}',
      '.zft__info.is-abierto .zft__pop{display:flex}',
      '@media (hover:hover){.zft__info:hover .zft__pop,.zft__i:focus-visible + .zft__pop{display:flex}}',
      '.zft__pop-fila{display:flex;justify-content:space-between;gap:10px}',
      '.zft__pop-fila b{font-weight:600;white-space:nowrap}',
      '.zft__pop-nota{margin:-2px 0 4px;font-size:11px;opacity:.6}',
      '.zft__msg{margin:0 0 4px;font-size:12px;line-height:1.45;opacity:.85}',
      '.zft__detalle{margin-top:16px;border-top:1px solid rgb(0 0 0/.08)}',
      '.zft__det{display:grid;grid-template-columns:70px 1.1fr 1fr 82px;gap:8px;align-items:center;padding:9px 0;border-bottom:1px solid rgb(0 0 0/.08);font-size:13px}',
      '.zft__det--cab{padding:0 0 6px;border-bottom-color:rgb(0 0 0/.2);font-size:11px;opacity:.65}',
      '.zft__det > span:last-child{text-align:right}',
      '.zft__tag{display:inline-block;margin-left:6px;padding:1px 6px;border:1px solid rgb(0 0 0/.35);font-size:11px;line-height:1.4;color:#5f5e5a;vertical-align:1px}',
      '.zft__tag--tuya{background:var(--zd-tinta,#242122);border-color:var(--zd-tinta,#242122);color:#fff}',
      '.zft__estado{display:inline-flex;align-items:center;justify-content:flex-end;gap:4px;font-size:12px}',
      '.zft__estado--ok{color:#2f6b1f}',
      '.zft__estado--justa{color:#8a5a00}',
      '.zft__estado--no{color:#b3261e}',
      '.zft__nota{margin:6px 0 0;font-size:11px;opacity:.6}',
      '.zft__perfil{margin-top:18px;padding:16px;border:1px solid var(--zd-linea,#e5e5e5)}.zft__perfil-cab{display:flex;justify-content:space-between;align-items:center;gap:12px;margin:-6px -8px 6px 0}.zft__perfil-cab .zft__label{margin:0}',
      '.zft__resumen{margin:0 0 10px;font-size:13px;line-height:1.5}',
      '.zft__acciones{display:flex;gap:18px}',
      '.zft__link{padding:0;border:0;background:none;color:inherit;font:inherit;font-size:13px;text-decoration:underline;text-underline-offset:3px;cursor:pointer}',
      '.zft__cargando{display:flex;align-items:center;justify-content:center;gap:10px;min-height:200px;font-size:14px}',
      '.zft__spin{width:16px;height:16px;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:zft-spin .7s linear infinite}',
      '@keyframes zft-spin{to{transform:rotate(360deg)}}',
      '.zft__toast{position:absolute;left:50%;top:64px;transform:translate(-50%,-8px);padding:10px 16px;background:var(--zd-tinta,#242122);color:#fff;font-size:13px;opacity:0;pointer-events:none;transition:opacity .25s ease,transform .25s ease;white-space:nowrap}',
      '.zft__toast.is-visible{opacity:1;transform:translate(-50%,0)}',
      '.zft__prod{display:flex;gap:14px;align-items:center}',
      '.zft__prod-foto{width:56px;height:70px;object-fit:cover;background:var(--zd-suave,#f5f5f5);flex:none}',
      '.zft__prod-nombre{margin:0;font-size:11px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:var(--zd-gris,#6b6b6b)}',
      '.zft__eti{display:block;margin:20px 0 0;font-size:11px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:var(--zd-gris,#6b6b6b)}',
      '.zft__eti--pegada{margin:0}',
      '.zft__grande{margin:4px 0 0;font-size:56px;font-weight:600;line-height:1;letter-spacing:-.03em}',
      '.zft__resumen{margin:8px 0 0;font-size:14px;line-height:1.5}',
      '.zft__resumen--sec{color:var(--zd-gris,#6b6b6b);font-size:13px}',
      '.zft__aviso{margin:14px 0 0;padding:12px 14px;border:1px solid var(--zd-tinta,#242122);font-size:13px;line-height:1.5}',
      '.zft__zonas{margin-top:22px}',
      '.zft__zb{display:grid;grid-template-columns:22px 1fr auto;column-gap:12px;align-items:center;width:100%;padding:13px 0;border:0;border-bottom:1px solid var(--zd-linea,#e5e5e5);background:none;color:inherit;font:inherit;text-align:left;cursor:pointer}',
      '.zft__zonas-nota + .zft__zb{border-top:1px solid var(--zd-linea,#e5e5e5)}',
      '.zft__zb-ico svg{display:block;width:20px;height:20px;fill:none;stroke:currentColor;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round}',
      '.zft__zb-n{font-size:14px}',
      '.zft__zb-f{font-size:13px;text-align:right}',
      '.zft__zb--mal .zft__zb-f{font-weight:600}',
      '.zft__zb-d{grid-column:2/-1;margin-top:4px;font-size:12px;color:var(--zd-gris,#6b6b6b)}',
      '.zft__zb-d[hidden]{display:none}',
      '.zft__zb:focus-visible{outline:2px solid var(--zd-tinta,#242122);outline-offset:2px}',
      '.zft__zonas-nota{margin:0 0 10px;font-size:13px;color:var(--zd-gris,#6b6b6b)}',
      '.zft__perfilc-caja{margin-top:22px;padding-top:16px;border-top:1px solid var(--zd-linea,#e5e5e5)}',
      '.zft__perfilc{display:flex;justify-content:space-between;align-items:center;gap:12px}',
      '.zft__perfilc-txt{min-width:0}',
      '.zft__perfilc-txt p:last-child{margin:2px 0 0;font-size:13px}',
      '.zft__perfilc-acc{display:flex;flex:none}',
      '.zft__ico{display:inline-grid;place-items:center;width:36px;height:36px;padding:0;border:0;border-radius:50%;background:transparent;color:var(--zd-tinta,#242122);cursor:pointer}',
      '.zft__ico:hover,.zft__ico:focus-visible{background:var(--zd-suave,#f5f5f5);outline:none}',
      '.zft__ico svg{width:18px;height:18px;fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round}',
      '.zft__cuenta{display:flex;flex-wrap:wrap;justify-content:space-between;align-items:center;gap:12px;margin-top:12px;padding:14px;border:1px solid var(--zd-linea,#e5e5e5);font-size:13px}',
      '.zft__btn--chico{display:inline-flex;align-items:center;min-height:36px;padding:0 14px;text-decoration:none}',
      '.zft__btn--blanco:hover{background:var(--zd-suave,#f5f5f5)}',
      '@media (pointer:coarse){.zft__ico{width:44px;height:44px}}',
      '@media all{',
      '.zft__campo{grid-template-columns:1fr}',
      '.zft__campo--nota{grid-template-areas:"label" "nota" "control"}',

      '.zft__res{grid-template-columns:96px 1fr}',
      '.zft__det{grid-template-columns:58px 1.2fr 1fr 70px;gap:6px;font-size:12px}',
      '.zft__tag{display:block;width:max-content;margin:3px 0 0}',
      '}',
      '@media (max-width:749px){.zft__head{padding:16px 18px}.zft__cuerpo{padding:16px 18px 8px}.zft__pie{padding:14px 18px calc(18px + env(safe-area-inset-bottom,0px))}}'
    ].join('');
    document.head.appendChild(h('style', { id: 'zft-estilos', text: css }));
  }

  /* Punto de "tu talla" en los botones de talla: siempre disponible (no espera a abrir la ventana) */
  function estilosMarca() {
    if (document.getElementById('zft-marca')) return;
    document.head.appendChild(h('style', {
      id: 'zft-marca',
      text: '[data-zd-rec]{position:relative}.zd-rec-dot{position:absolute;top:6px;right:4px;width:5px;height:5px;border-radius:50%;background:var(--zd-tinta,#242122);pointer-events:none;z-index:1}' +
        '.zd-tu-talla{position:absolute;z-index:3;left:8px;bottom:8px;padding:4px 8px;background:#fff;color:var(--zd-tinta,#242122);font:600 11px/1.2 var(--zd-fuente,inherit);letter-spacing:.02em;box-shadow:0 1px 4px rgb(0 0 0 / .12);pointer-events:none;transition:opacity .2s}' +
        '@media (hover:hover){:hover>.zd-tu-talla{opacity:0}}:has(>.zd-root .zd-panel.is-open)>.zd-tu-talla{opacity:0}' +
        '.zd-aviso-talla{position:fixed;z-index:2147483000;left:50%;bottom:calc(20px + env(safe-area-inset-bottom,0px));transform:translateX(-50%);display:flex;align-items:center;gap:16px;width:max-content;max-width:calc(100vw - 32px);padding:12px 16px;background:var(--zd-tinta,#242122);color:#fff;font:400 14px/1.4 var(--zd-fuente,inherit);box-shadow:0 8px 24px rgb(0 0 0 / .2)}' +
        '.zd-aviso-talla button{flex:none;padding:0;border:0;background:none;color:#fff;font:600 11px var(--zd-fuente,inherit);letter-spacing:.1em;text-transform:uppercase;cursor:pointer}'
    }));
  }

  /* ------------------------------------------------------------------ Arranque */
  var ultimoBoton = null;
  window.addEventListener('click', function (e) {
    var f = e.target && e.target.closest && e.target.closest(SELECTOR_FINDER);
    if (f) ultimoBoton = f;
  }, true);

  /* Enlaces que no lanzan el evento por su cuenta (página de producto) */
  document.addEventListener('click', function (e) {
    var f = e.target && e.target.closest && e.target.closest('[data-zd-finder]');
    if (!f || f.tagName === 'A' || f.closest('[data-zd-panel]')) return;
    e.preventDefault();
    abrir(f.getAttribute('data-product-handle'), f);
  });
  document.addEventListener('zendelaya:size-finder', function (e) {
    var handle = e.detail && e.detail.product;
    var boton = ultimoBoton && ultimoBoton.getAttribute('data-product-handle') === handle ? ultimoBoton : null;
    abrir(handle, boton);
  });

  function iniciar() {
    leerConfig();
    estilosMarca();
    marcarTodo();
    aplicarRegistroPagina();
    new MutationObserver(function (lista) {
      for (var i = 0; i < lista.length; i++) {
        if (lista[i].addedNodes.length) { programarMarcado(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', function (e) { if (e.key === CLAVE) marcarTodo(); });
    /* Enlace directo desde menús y páginas: cualquier dirección que termine en #encuentra-tu-talla abre el perfil */
    porEnlace();
    window.addEventListener('hashchange', porEnlace);
  }
  function porEnlace() {
    if (location.hash !== '#encuentra-tu-talla') return;
    try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {}
    editarPerfil();
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href$="#encuentra-tu-talla"]');
    if (!a) return;
    var u;
    try { u = new URL(a.href, location.href); } catch (x) { return; }
    if (u.pathname !== location.pathname) return;
    e.preventDefault();
    editarPerfil();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();

  window.ZendelayaTalla = {
    abrir: abrir,
    editarPerfil: editarPerfil,
    perfil: leerPerfil,
    registroPara: registroPara,
    borrar: borrarPerfil
  };
})();
